import React from 'react';
import {
  Typography,
  Box,
  Grid,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Checkbox,
  ListItemText,
  ListItem,
  CardContent,
  Card,
  IconButton,
  Divider,
  Button,
  Popover,
  makeStyles,
  ButtonBase,
  Popper,
  ClickAwayListener,
  ButtonGroup,
  Tooltip,
  CircularProgress,
  useMediaQuery,
} from '@material-ui/core';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
  TimePicker,
  KeyboardTimePicker,
} from '@material-ui/pickers';
import LoginScreen from 'components/LoginScreen';
import ScheduleIcon from '@material-ui/icons/Schedule';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import momentDurationFormat from 'moment-duration-format';
import DynamicIcon from 'components/Common/DynamicIcon';
import InfiniteScroll from 'react-infinite-scroll-component';
import AutoSizer from 'react-virtualized-auto-sizer';
import { sendAmplitudeData } from 'util/amplitude';
import {
  CancelOutlined,
  CheckCircleOutline,
  KeyboardArrowDown,
  CloseOutlined,
  Add,
  Remove,
  SearchOutlined,
  SendRounded,
  RemoveCircle,
  LocationOn,
  MyLocationOutlined,
} from '@material-ui/icons';
import debounce from 'lodash.debounce';
import Fade from '@material-ui/core/Fade';

import {
  ClickableTableWidget,
  DescriptionWithIconButtonWidget,
  getGradient,
  ImagePreview,
  TabularSearchResults,
} from './BasicWidgets';
import { get } from 'lodash';
import { textFieldInputParser } from 'util/InputUtils';
import { SearchBlock } from 'components/Common/SearchBlock';
import { CardWidget } from '.';
import { Input } from '@material-ui/core';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { OrderSearchResults } from './BasicWidgets';
import Cart from '../../Common/Cart';
import { Autocomplete, Skeleton } from '@material-ui/lab';
import { uploadFile } from 'services/files';
import { FileTypeIcons } from 'components/Common/DynamicIcon';
import { getCoords, getMapCenter } from 'services/Geolocation';
import { persistentStore } from 'services/storage';
import { GoogleLocationSelector } from 'components/Common/GoogleLocationPicker';
import { apiGet } from 'services/api';
import { searchPreProcessor, locationPreProcessor } from 'util/LocationUtils';
import { configure, GlobalHotKeys } from 'react-hotkeys';
import NewMapComponent from 'components/Common/NewMapContainer';
import { preventDefaultHandlers } from 'util/misc';
import { DropdownField, DateField } from '../../Common/Filters';

const useStyles = makeStyles((theme) => ({
  root: {
    '&.MuiSkeleton-root': {
      backgroundColor: '#f9f9f9',
    },
  },
  radio: {
    color: '#c8c8c8',
    '&$checked': {
      color: '#7467F0',
    },
  },
  borderedField: {
    flex: 1,
    fontSize: '1rem',
    padding: '18.5px 14px',
    cursor: 'pointer',
    color: '#909090',
  },
  borderedFieldBase: {
    border: '1px solid #C4C4C4',
    borderRadius: 4,
    '&:hover': { borderColor: '#000000' },
  },
  focusedDropdown: {
    border: '2px solid #233C97',
    borderRadius: 4,
  },
  popper: {
    zIndex: theme.zIndex.modal,
  },
  inputLabelNoShrink: {
    transform: 'translate(32px, 24px) scale(1)',
  },
  filterContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    height: 56,
    marginTop: 8,
    overflow: 'auto',
    maxWidth: 'calc(100vw - 30px)',
    flexWrap: 'nowrap',
    '&::-webkit-scrollbar': {
      height: 0,
      width: 0,
    },
  },
  filterBox: {
    display: 'flex',
    border: '1px solid #E2E2E2',
    borderRadius: 5,
    color: '#898989',
    height: 'inherit',
  },
  clearButton: {
    border: '1px solid #E2E2E2',
    fontSize: '12px',
    borderRadius: 5,
    color: '#898989ff',
    marginLeft: 20,
    height: 'inherit',
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    marginBottom: theme.spacing(4),
    width: 420,
    borderRadius: 20,
    background:
      'transparent linear-gradient(0deg, #ffffff 0%, #ffffff 100%) 0% 0% no-repeat padding-box',
    height: 100,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  mapLabel: {
    background: '#233C97',
    padding: '2px 4px',
    borderRadius: 4,
    border: '1px solid #dddddd',
    opacity: 0.8,
  },
}));

momentDurationFormat(moment);

function ChecklistWidget({ title, icons, children, setFormState }) {
  return (
    <Box
      style={{
        border: '1px solid #dddddd',
        marginTop: 15,
        display: 'flex',
        alignItems: 'flex-start',
        padding: 20,
        flexDirection: 'column',
      }}
    >
      <Grid container>
        <Grid item xs={icons ? 9 : 12}>
          <Typography variant="h6">{title}</Typography>{' '}
        </Grid>
        {icons && (
          <Grid
            item
            xs={3}
            align="right"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            <ButtonGroup
              color="primary"
              aria-label="outlined primary button group"
            >
              {icons.map(({ iconId }, index) => (
                <Button>
                  <DynamicIcon iconId={iconId} className />
                </Button>
              ))}
            </ButtonGroup>
          </Grid>
        )}
      </Grid>
      {children}
    </Box>
  );
}

export function ChecklistRadioWidget({ title, radio, icons, setFormState }) {
  const selected = radio && radio.find((option) => option.selected);
  return (
    <ChecklistWidget title={title} icons={icons}>
      <RadioGroup row value={selected && selected.title}>
        {radio &&
          radio.map((option) => (
            <FormControlLabel
              value={option.title}
              control={<Radio color="primary" />}
              label={option.title}
            />
          ))}
      </RadioGroup>
    </ChecklistWidget>
  );
}

export function ChecklistTextWidget({ title, hint, icons, setFormState }) {
  return (
    <ChecklistWidget title={title} icons={icons}>
      <TextField label={hint} />
    </ChecklistWidget>
  );
}

function relationalValueReducer(relation, formData, currentValue) {
  let relationalKey = relation['key'];
  let factor = relation['factor'];
  let operation = relation['operation'];
  let relatedFieldValue = parseFloat(formData[relationalKey]) || 0;
  let key2;
  switch (operation) {
    case 0:
      currentValue = factor + relatedFieldValue;
      break;
    case 1:
      currentValue = factor * relatedFieldValue;
      break;
    case 2:
      currentValue = (relation['factor'] / 100) * relatedFieldValue;
      break;
    case 3:
      key2 = relation['key2'];
      currentValue = (formData[key2] / 100 || 0) * relatedFieldValue;
      break;
    case 4:
      key2 = relation['key2'];
      currentValue = parseFloat(
        (relatedFieldValue - (formData[key2] || 0)).toFixed(2)
      );
      break;
    default:
      break;
  }
  return currentValue;
}

export function InputTextWidget({
  text,
  hint,
  maxLength,
  inputAllowed,
  isRequired,
  multiline,
  _key,
  setFormState,
  resetFormState,
  hideHelperText,
  formData,
  deep_link,
  apiType,
  relation,
  readOnly,
  onFieldUpdate,
  enterDeeplink,
  ...props
}) {
  function useDebounce(callback, delay) {
    const debouncedFn = React.useCallback(
      debounce((...args) => callback(...args), delay),
      [delay]
    );
    return debouncedFn;
  }
  React.useEffect(() => {
    (!!text || text === 0 || text === '') &&
      setFormState({ [_key]: convertDataType(text, inputAllowed) });
  }, [text]);

  React.useEffect(() => {
    let cachedValue = persistentStore.get(_key);
    !!cachedValue &&
      !text &&
      text !== '' &&
      setFormState({ [_key]: cachedValue });
  }, []);
  const convertDataType = (val, dataType) =>
    (val || val === '') && dataType === 3 ? parseInt(val || 0) : val;

  const getFieldValue = (value) => {
    if (relation) {
      let finalValue = relationalValueReducer(relation, formData, value);
      return finalValue;
    }
    return convertDataType(value, inputAllowed);
  };

  const updateFormField = (
    _key,
    value,
    deeplink,
    apiType,
    formData,
    resetForm
  ) => {
    props
      .handleDeeplink(deeplink, apiType || 2, { ...formData, [_key]: value })
      .then((response) => {
        if (response) {
          response.refreshDeeplink &&
            (onFieldUpdate || props.setDeepLink || (() => {}))(
              response.refreshDeeplink
            );
          ((resetForm && resetFormState) || (() => {}))();
        }
      });
  };
  const debouncedUpdateFormField = useDebounce(
    (_key, value, deeplink, apiType, formData) => {
      updateFormField(_key, value, deeplink, apiType, formData);
    },
    1000
  );

  const handleFormFieldChange = (_key, value, deeplink, apiType, formData) => {
    debouncedUpdateFormField(_key, value, deeplink, apiType, formData);
  };

  return (
    <div style={{ margin: '10px' }}>
      <TextField
        autoFocus={props.autoFocus}
        label={hint}
        size={props.size}
        value={getFieldValue(formData[_key] || '') || ''}
        variant="outlined"
        fullWidth={true}
        multiline={multiline}
        {...(multiline ? { rows: 3, rowsMax: 4 } : {})}
        required={isRequired}
        onChange={(e) => {
          deep_link &&
            handleFormFieldChange(
              _key,
              convertDataType(e.target.value, inputAllowed),
              deep_link,
              apiType,
              formData
            );
          setFormState({
            [_key]: convertDataType(e.target.value, inputAllowed),
          });
        }}
        inputProps={{
          maxLength: maxLength,
          readOnly: readOnly && true,
          style: { background: readOnly && '#e8e8e888' },
        }}
        helperText={
          ![3, 4, 7].includes(inputAllowed) &&
          maxLength &&
          `${(formData[_key] || text || '').length}/${maxLength}`
        }
        onKeyPress={(e) => {
          enterDeeplink &&
            e.key === 'Enter' &&
            updateFormField(
              _key,
              formData[_key],
              enterDeeplink,
              apiType,
              formData,
              true
            );
          const regex = /^[0-9.]+$/;
          if ([3, 4, 7].includes(inputAllowed) && !regex.test(e.key)) {
            e.preventDefault();
          }
        }}
      />
    </div>
  );
}

export function InputDateWidget({
  timeOnly,
  date,
  time,
  hint,
  format,
  isRequired,
  disablePastDates,
  disableFuture,
  _key,
  setFormState,
  removeEntries,
  formData,
  deep_link,
  apiType,
}) {
  // const [value, setValue] = React.useState(date && moment.unix(date));
  // React.useEffect(
  //   () => setFormState(_key, value && value.unix()),
  //   [setFormState, _key, value, format]
  // );
  // console.log(date)
  const [error, setError] = React.useState(false);
  React.useEffect(() => {
    date && setFormState({ [_key]: date });
  }, [date]);
  React.useEffect(() => {
    time && setFormState({ [_key]: date });
  }, [time]);

  return (
    <div style={{ padding: 10 }}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        {!timeOnly ? (
          <KeyboardDatePicker
            disablePast={disablePastDates}
            disableFuture={disableFuture}
            label={hint}
            required={isRequired}
            format={format || 'DD/MM/YYYY'}
            inputVariant="outlined"
            error={error}
            helperText={error && 'Invalid Date'}
            value={formData[_key] ? moment.unix(formData[_key]) : null}
            onChange={(value) => {
              value && !value.isValid() && setError(true);
              (!value || (value && value.isValid())) && setError(false);
              value &&
                value.isValid() &&
                setFormState(
                  { [_key]: value && value.unix() },
                  deep_link,
                  apiType
                );
              !value && removeEntries([_key]);
            }}
            fullWidth={true}
            cancelLabel={
              <Typography style={{ fontWeight: 'bold' }}>CANCEL</Typography>
            }
            okLabel={<Typography style={{ fontWeight: 'bold' }}>OK</Typography>}
          />
        ) : (
          <KeyboardTimePicker
            required={isRequired}
            label={hint}
            margin="normal"
            inputVariant="outlined"
            value={
              formData[_key] || time
                ? moment.unix(formData[_key] || time)
                : null
            }
            onChange={(value) =>
              setFormState(
                { [_key]: value && value.unix() },
                deep_link,
                apiType
              )
            }
            KeyboardButtonProps={{
              'aria-label': 'change time',
            }}
            fullWidth={true}
            keyboardIcon={<ScheduleIcon />}
            cancelLabel={
              <Typography style={{ fontWeight: 'bold' }}>CANCEL</Typography>
            }
            okLabel={<Typography style={{ fontWeight: 'bold' }}>OK</Typography>}
          />
        )}
      </MuiPickersUtilsProvider>
    </div>
  );
}

export function DropdownWidget({
  title,
  selected,
  _key,
  sectionIndex,
  setFormState,
  multiselect,
  deep_link,
  apiType,
  selectionCards,
  interpolateSections,
  handleDeeplink,
  formData,
  removeEntries,
  ...props
}) {
  const classes = useStyles();
  const [selection, setSelection] = React.useState(props.selection);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [localState, setLocalState] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [selectedFilters, setSelectedFilters] = React.useState(
    !!props.filter && props.filter.selected
      ? { [props.filter.key]: props.filter.selected }
      : !!props.filter
      ? {}
      : null
  );
  // const [value, setValue] = React.useState(selected || '');
  // React.useEffect(
  //   () => setFormState(_key, value),
  //   [setFormState, _key, value]
  // );
  const open = Boolean(anchorEl);

  const setLocalFormState = (newState) => {
    setLocalState(newState[_key]);
  };

  React.useEffect(() => {
    selected && setFormState({ [_key]: selected });
    return () => {
      setAnchorEl(null);
    };
  }, [selected]);

  React.useEffect(() => {
    (interpolateSections || (() => {}))(
      (selectionCards || {})[selected],
      sectionIndex,
      0
    );
  }, [selectionCards, sectionIndex, selected]);

  const handleChange = (value) => {
    (interpolateSections || (() => {}))(
      (selectionCards || {})[value],
      sectionIndex,
      (selectionCards || {})[formData[_key] || selected].length || 0
    );
    setFormState({ [_key]: value });
  };

  const queryFunction = (searchString, searchResults, setList) => {
    if ((searchString || '').length !== 0) {
      let searchRegExp = new RegExp((searchString || '').toLowerCase());

      setList(
        selection.filter((item) =>
          searchRegExp.test((item.title || '').toLowerCase())
        )
      );
    } else {
      setList(selection);
    }
  };

  const checkSelected = (item) => {
    return !!(formData[_key] || localState || selected || []).find(
      (option) => option === item.id
    );
  };

  const checkSelectAll = () => {
    let allSelected = true;
    if (
      selection.length === 0 ||
      (formData[_key] || localState || selected || []).length < selection.length
    )
      return false;
    else {
      (selection || []).forEach((element) => {
        if (!(formData[_key] || []).includes(element.id)) {
          allSelected = false;
          return false;
        }
      });
    }
    return allSelected;
  };

  const selectAllHandle = () => {
    let newState = [];
    if (checkSelectAll()) {
      newState = (formData[_key] || []).filter(
        (ele) => !(selection || []).find((sel) => sel.id === ele)
      );
      (setFormState || (() => {}))({
        [_key]: newState,
      });
      setLocalState(newState);
    } else {
      newState = [
        ...(formData[_key] || []),
        ...(
          (selection || []).filter(
            (ele) => !(formData[_key] || []).includes(ele.id)
          ) || []
        ).map((element) => element.id),
      ];
      (setFormState || (() => {}))({
        [_key]: newState,
      });
      setLocalState(newState);
    }
  };

  const onSelect = (selectedItem) => {
    const newState = multiselect
      ? !!(formData[_key] || localState || []).find(
          (option) => option === selectedItem.id
        )
        ? {
            [_key]: (formData[_key] || localState).filter(
              (item) => item !== selectedItem.id
            ),
          }
        : { [_key]: [...(formData[_key] || localState || []), selectedItem.id] }
      : { [_key]: selectedItem.id };

    (interpolateSections || (() => {}))(
      (selectionCards || {})[selectedItem.id],
      sectionIndex,
      ((selectionCards || {})[formData[_key] || selected] || 0).length
    );

    !!deep_link
      ? multiselect
        ? setLocalFormState(newState)
        : handleDeeplink(deep_link, apiType, {
            [_key]: selectedItem.id,
          })
      : setFormState(newState);
    !multiselect && setAnchorEl(null);
  };

  const selectFilter = (key, value) => {
    selectedFilters[props.filter.key] !== value &&
      !loading &&
      setSelectedFilters({
        [key]: value,
      });
  };

  React.useEffect(() => {
    if (selectedFilters && Object.keys(selectedFilters).length > 0) {
      setLoading(true);
      handleDeeplink(
        `/${props.filter.baseDeepLink}${
          Object.keys(selectedFilters).length > 0
            ? `query${Object.keys(selectedFilters || {}).reduce(
                (queryString, currentFilter) =>
                  queryString +
                  `/${currentFilter}/${selectedFilters[currentFilter]}`,
                ''
              )}`
            : ''
        }`
      ).then((response) => {
        setLoading(false);
        if (response) {
          response.selection && setSelection(response.selection);
        }
      });
    }
  }, [selectedFilters]);

  return (
    <div style={{ padding: '10px' }}>
      <div style={{ width: '100%', maxWidth: '100%' }}>
        <ButtonBase
          className={classes.borderedFieldBase}
          focusVisibleClassName={classes.focusedDropdown}
          style={{
            width: '100%',
            maxWidth: '100%',
            textAlign: 'left',
            ...(!!anchorEl ? { borderColor: '#233C97', borderWidth: 2 } : {}),
          }}
          onClick={(event) => setAnchorEl(event.currentTarget)}
        >
          <div
            className={classes.borderedField}
            style={{
              maxWidth: '100%',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              color: !!formData[_key] && formData[_key].length > 0 && '#000000',
            }}
          >
            <Typography
              noWrap
              style={{ maxWidth: '80%', textOverflow: 'ellipsis' }}
            >
              {(multiselect
                ? (formData[_key] || localState || []).reduce(
                    (valueString, currentItem, index) =>
                      `${valueString}${index > 0 ? ', ' : ''}${
                        (
                          selection.find((item) => item.id === currentItem) ||
                          {}
                        ).title || ''
                      }`,
                    ''
                  )
                : (selection.find((item) => item.id === formData[_key]) || {})
                    .title) || title}
            </Typography>
            <DynamicIcon iconId={933} style={{ height: 20, width: 20 }} />
          </div>
        </ButtonBase>
        {multiselect && deep_link && (
          <div
            style={{
              marginTop: 10,
              width: '100%',
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              style={{
                background:
                  'transparent linear-gradient(240deg, #7467F0 0%, #2896E9 100%) 0% 0% no-repeat padding-box',
                color: '#ffffff',
              }}
              onClick={() =>
                handleDeeplink(deep_link, apiType, {
                  [_key]: formData[_key] || localState || selected,
                })
              }
            >
              Submit
            </Button>
          </div>
        )}
      </div>

      <Popper
        label={title}
        open={open}
        anchorEl={anchorEl}
        placement="bottom-start"
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        style={{
          width: props.isMobile ? 'calc( 100vw - 20px )' : '30vw',
        }}
        className={classes.popper}
      >
        <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
          <Card elevation={8}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                marginRight: 16,
              }}
            >
              <IconButton
                edge="end"
                onClick={() => setAnchorEl(null)}
                aria-label="close"
                style={{ padding: 0, color: '#757575' }}
              >
                <CloseOutlined />
              </IconButton>
            </div>
            {props.filter && (
              <div
                className={classes.filterContainer}
                style={{ padding: '0px 8px', overflow: 'auto' }}
              >
                {(props.filter.items || []).map((curFilter, index) => (
                  <Button
                    disableRipple={
                      selectedFilters[props.filter.key] === curFilter.value ||
                      loading
                    }
                    key={index}
                    style={{
                      paddingLeft: 16,
                      paddingRight: 16,
                      border: '1px solid #E2E2E2',
                      marginRight: index < props.filter.items.length - 1 && 12,

                      fontSize: '12px',
                      ...(selectedFilters[props.filter.key] === curFilter.value
                        ? {
                            backgroundColor: '#233C9722',
                            color: '#233C97ff',
                          }
                        : { color: '#898989ff' }),
                      whiteSpace: 'nowrap',
                      minWidth: 'max-content',
                      fontWeight: 'bold',
                    }}
                    onClick={() => {
                      selectFilter(props.filter.key, curFilter.value);
                    }}
                  >
                    {curFilter.title}
                    {selectedFilters[props.filter.key] === curFilter.value && (
                      <CloseOutlined
                        onClick={(event) => {
                          event.stopPropagation();
                          // setLoading(true);
                          setSelectedFilters({});
                          setSelection(props.selection);
                        }}
                        style={{ fontSize: 16, marginLeft: 4 }}
                      />
                    )}
                  </Button>
                ))}
              </div>
            )}
            <div style={{ maxHeight: 280, overflowY: 'auto' }}>
              <SearchBlock
                isMobile={props.isMobile}
                onSelect={onSelect}
                selection={selection}
                checkSelected={checkSelected}
                multiselect={multiselect}
                checkSelectAll={checkSelectAll}
                queryFunction={queryFunction}
                selectAllHandle={selectAllHandle}
              />
            </div>
            <ButtonBase
              style={{
                width: '100%',
                height: '80%',
                maxWidth: '100%',
                borderTop: '1px solid #dddddd',
              }}
            >
              <Button
                style={{ width: '100%' }}
                color="primary"
                size="large"
                onClick={() => {
                  (setFormState || (() => {}))({ [_key]: null });
                  removeEntries([_key]);
                  setLocalState(null);
                  setAnchorEl(null);
                }}
              >
                CLEAR SELECTION
              </Button>
            </ButtonBase>
          </Card>
        </ClickAwayListener>
      </Popper>
    </div>
  );
}

export function RadioWidget({
  title,
  _key,
  radio,
  row,
  setFormState,
  formData,
  deep_link,
  apiType,
}) {
  const classes = useStyles();
  const selected = radio && radio.find((option) => option.selected);

  React.useEffect(() => {
    selected && setFormState({ [_key]: selected.value || selected.title });
  }, [selected]);

  return (
    <div
      style={{
        padding: '16px 16px',
        minWidth: '25vw',
        maxWidth: '100%',
        border: '1px solid #c4c4c4',
        margin: 10,
        marginTop: 15,
        borderRadius: 6,
      }}
    >
      <Typography style={{ fontWeight: 'bold', color: '#707070' }}>
        {title}
      </Typography>
      <RadioGroup
        row={row}
        value={
          formData[_key] || (selected || {}).value || (selected || {}).title
        }
        style={{ display: 'flex', flex: 1 }}
        onChange={(e) => {
          setFormState({ [_key]: e.target.value }, deep_link, apiType);
        }}
      >
        {radio &&
          radio.map((option) => (
            <FormControlLabel
              value={option.value || option.title}
              control={<Radio color="primary" className={classes.radio} />}
              style={{ color: '#909090' }}
              label={option.title}
            />
          ))}
      </RadioGroup>
    </div>
  );
}

export function ChecklistOptionWidget({
  parent,
  setFormState,
  formData,
  deep_link,
  ...props
}) {
  const [options, setOptions] = React.useState(null);
  const [multipleChoice, setMultipleChoice] = React.useState(false);

  React.useEffect(() => {
    if (!multipleChoice) {
      setOptions(null);
      return;
    }
    const optionsWidget = parent.content.find(
      (widget) => widget.card_content_type === 'card_50'
    ); // find sibling widget
    setOptions(
      [1, 2, 3, 4]
        .filter((index) => optionsWidget[`key${index}`]) // remove missing keys
        .map((index) => ({
          key: optionsWidget[`key${index}`],
          option: optionsWidget[`option${index}`],
        }))
    );
  }, [multipleChoice, setFormState, parent]);

  const onTypeChange = (_key, value) => {
    value && setFormState({ [_key]: value });
    setMultipleChoice(value === 'Multiple Choice');
  };

  return (
    <>
      <DropdownWidget {...props} onFormStateChange={onTypeChange} />
      {multipleChoice &&
        options &&
        options.map(({ key, option }, index) => (
          <InputTextWidget
            key={key}
            hint={key}
            _key={key}
            text={option}
            hideHelperText={true}
            setFormState={(value) => setFormState(value, deep_link)}
          />
        ))}
    </>
  );
}

export function HorizontalRadioWidget(props) {
  return <RadioWidget {...props} row={true} />;
}

export function DropdownWidgetLarge({
  title,
  description,
  multiselect,
  interpolateSections,
  selectionCards,
  sectionIndex,
  selection,
  selected,
  _key,
  setFormState,
  formData,
  deep_link,
  apiType,
}) {
  const [value, setValue] = React.useState(selected || (multiselect ? [] : ''));
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);

  React.useEffect(() => {
    selected && setFormState({ [_key]: selected });
  }, [selected]);

  React.useEffect(() => {
    (interpolateSections || (() => {}))(
      (selectionCards || {})[selected],
      sectionIndex,
      0
    );
  }, [selectionCards, sectionIndex, selected]);

  const queryFunction = (searchString, searchResults, setList) => {
    if ((searchString || '').length !== 0) {
      let searchRegExp = new RegExp((searchString || '').toLowerCase());

      setList(
        selection.filter((item) =>
          searchRegExp.test((item.title || '').toLowerCase())
        )
      );
    } else {
      setList(selection);
    }
  };

  const checkSelected = (item) => {
    return (formData[_key] || selected).includes(item.id);
  };

  const onSelect = (selectedItem) => {
    (interpolateSections || (() => {}))(
      (selectionCards || {})[selectedItem.id],
      sectionIndex,
      ((selectionCards || {})[formData[_key] || selected] || 0).length
    );
    const newState = multiselect
      ? (formData[_key] || []).includes(selectedItem.id)
        ? { [_key]: formData[_key].filter((item) => item !== selectedItem.id) }
        : { [_key]: [...(formData[_key] || []), selectedItem.id] }
      : { [_key]: selectedItem.id };
    setFormState(newState);
    !multiselect && setAnchorEl(null);
  };

  return (
    <div
      style={{
        padding: '20px 30px 20px 30px',
        minWidth: '25vw',
        maxWidth: '100%',
        marginTop: 15,
        border: '1px solid #dddddd',
      }}
    >
      <Typography variant="h6" style={{ fontWeight: 'bold', color: '#909090' }}>
        {title}
      </Typography>
      <ButtonBase style={{ width: '100%', textAlign: 'left' }}>
        <div
          onClick={(event) => setAnchorEl(event.currentTarget)}
          style={{
            flex: 1,
            borderBottom: '1px solid #C4C4C4',
            fontSize: '1rem',
            padding: '18.5px 14px 10px 0px',
            cursor: 'pointer',
            color: '#909090',
          }}
        >
          {(multiselect
            ? (formData[_key] || selected || []).reduce(
                (valueString, currentItem, index) =>
                  `${valueString}${index > 0 ? ', ' : ''}${
                    (selection.find((item) => item.id === currentItem) || {})
                      .title || ''
                  }`,
                ''
              )
            : (
                selection.find(
                  (item) => item.id === (formData[_key] || selected)
                ) || {}
              ).title) || description}
        </div>
      </ButtonBase>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          style: {
            width: '50vw',
          },
        }}
      >
        <SearchBlock
          onSelect={onSelect}
          selection={selection}
          checkSelected={checkSelected}
          multiselect={multiselect}
          queryFunction={queryFunction}
        />
      </Popover>
    </div>
  );
}

export function MultipleSelection({
  title,
  selections,
  setFormState,
  formData,
  deep_link,
}) {
  React.useEffect(() => {
    selections.reduce(
      (formData, currentSelection) => ({
        ...formData,
        [currentSelection.key]: currentSelection.selected,
      }),
      {}
    ) &&
      setFormState(
        selections.reduce(
          (formData, currentSelection) => ({
            ...formData,
            [currentSelection.key]: currentSelection.selected,
          }),
          {}
        )
      );
  }, [selections]);

  return (
    <div
      style={{
        padding: '20px 40px 20px 40px',
        width: '25vw',
        maxWidth: '25vw',
        border: '1px solid #dddddd',
      }}
    >
      <Typography variant="h6" style={{ fontWeight: 'bold', color: '#909090' }}>
        {title}
      </Typography>
      <div
        style={{
          display: 'flex',
          alignItems: 'baseline',
          justifyContent: 'space-between',
        }}
      >
        {selections.map((selection) => (
          <>
            {selection.prefix && (
              <Typography style={{ color: '#909090' }}>
                {selection.prefix}
              </Typography>
            )}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-around',
                alignItems: 'baseline',
                width: '40%',
              }}
            >
              <FormControl size="small" fullWidth>
                <InputLabel id={selection.key}>
                  {(selection.multiselect
                    ? (formData[selection.key] || []).length === 0
                    : !(formData[selection.key] || selection.selected)) &&
                    selection.hint}
                </InputLabel>
                <Select
                  label={selection.hint}
                  value={formData[selection.key] || selection.selected}
                  multiple={selection.multiselect}
                  IconComponent={(props) => (
                    <KeyboardArrowDown
                      {...props}
                      style={{ color: '#909090' }}
                    />
                  )}
                  id={selection.key}
                  onChange={(e) =>
                    setFormState({ [selection.key]: e.target.value })
                  }
                >
                  {selection.options &&
                    selection.options.map((menuItem) => (
                      <MenuItem
                        value={menuItem.id}
                        component={(props) => (
                          <ListItem
                            button
                            style={{ cursor: 'pointer' }}
                            {...props}
                          >
                            {selection.multiselect && (
                              <Checkbox
                                style={{ padding: 0, marginRight: 8 }}
                                checked={formData[selection.key].includes(
                                  menuItem.id
                                )}
                              />
                            )}
                            <ListItemText primary={menuItem.title} />
                          </ListItem>
                        )}
                      >
                        {menuItem.title}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </div>
            {selection.suffix && (
              <Typography style={{ color: '#909090' }}>
                {selection.suffix}
              </Typography>
            )}
          </>
        ))}
      </div>
    </div>
  );
}

export function MultipleDatePicker({
  title,
  timeFields,
  setFormState,
  formData,
  deep_link,
}) {
  React.useEffect(() => {
    timeFields.reduce(
      (formData, currentTimeField) => ({
        ...formData,
        [currentTimeField.key]: currentTimeField.date,
      }),
      {}
    ) &&
      setFormState(
        timeFields.reduce(
          (formData, currentTimeField) => ({
            ...formData,
            [currentTimeField.key]: currentTimeField.date || moment.unix(),
          }),
          {}
        )
      );
  }, [timeFields]);

  return (
    <div
      style={{
        padding: '20px 40px 20px 40px',
        width: '30vw',
        maxWidth: '30vw',
        border: '1px solid #dddddd',
        marginTop: 15,
      }}
    >
      <Typography
        gutterBottom
        variant="h6"
        style={{ fontWeight: 'bold', color: '#909090' }}
      >
        {title}
      </Typography>
      <div
        style={{
          display: 'flex',
          alignItems: 'baseline',
          justifyContent: 'space-between',
        }}
      >
        {timeFields.map((timeField) => (
          <>
            {timeField.prefix && (
              <Typography style={{ color: '#909090' }}>
                {timeField.prefix}
              </Typography>
            )}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '40%',
              }}
            >
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <TimePicker
                  clearable
                  variant="inline"
                  ampm={true}
                  label={
                    !(formData[timeField.key] || timeField.date) &&
                    timeField.hint
                  }
                  value={moment.unix(formData[timeField.key] || timeField.date)}
                  onChange={(time) =>
                    setFormState({ [timeField.key]: time.unix() })
                  }
                />
              </MuiPickersUtilsProvider>
            </div>
            {timeField.suffix && (
              <Typography style={{ color: '#909090' }}>
                {timeField.suffix}
              </Typography>
            )}
          </>
        ))}
      </div>
    </div>
  );
}

export function SelectableCardWidget({
  options,
  selected,
  _key,
  formData,
  setFormState,
  deep_link,
}) {
  // const [values, setValues] = React.useState(selected || []);
  // React.useEffect(() => setFormState(_key, values), [
  //   setFormState,
  //   _key,
  //   values,
  // ]);

  const selectCard = (id) => {
    setFormState({ [_key]: [...(formData[_key] || selected || []), id] });
  };

  const deSelectCard = (id) => {
    setFormState({
      [_key]: (formData[_key] || selected || []).filter(
        (value) => value !== id
      ),
    });
  };

  React.useEffect(() => {
    selected && setFormState({ [_key]: selected });
  }, [selected]);

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        alignItems: 'baseline',
        flexWrap: 'wrap',
      }}
    >
      {(options || []).map(({ card_content_id, title, subtitle }) => (
        <Card
          style={{
            width: 400,
            marginBottom: 40,
            boxShadow: '0px 2.5px 20px #0000002d',
            borderRadius: '10px',
            borderRight: '15px solid #2896E9',
            marginRight: 75,
          }}
        >
          <CardContent
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '30px 20px 30px 50px',
            }}
          >
            <Box>
              <Typography
                gutterBottom
                style={{
                  fontSize: '20px',
                  color: '#505050',
                  letterSpacing: 1,
                }}
              >
                {title}
              </Typography>
              {subtitle && (
                <Typography color="textSecondary" style={{ fontSize: '16px' }}>
                  {subtitle}
                </Typography>
              )}
            </Box>
            <Checkbox
              onChange={
                (formData[_key] || selected || []).includes(card_content_id)
                  ? () => deSelectCard(card_content_id)
                  : () => selectCard(card_content_id)
              }
              selected={(formData[_key] || selected || []).includes(
                card_content_id
              )}
            />
          </CardContent>
        </Card>
      ))}
    </div>
  );
}

export const GoalWidget = (props) => {
  const { title, subtitle, timer, stage, handleDeeplink } = props;

  const [timeLeft, setTimeLeft] = React.useState();
  const [open, setOpen] = React.useState(false);
  const [date, setDate] = React.useState((timer || {}).date || moment().unix());
  const [updatedDate, setUpdatedDate] = React.useState();
  const [progressBoxWidth, setProgressBoxWidth] = React.useState();

  const buttonRef = React.useRef();
  const progressBoxRef = React.useRef();

  const calculateTime = () => {
    const targetDate = moment.unix(date);
    const currentDate = moment();
    const countdown = moment.duration(targetDate.diff(currentDate));

    let formattedCountdown = moment
      .duration(countdown, 'minutes')
      .format('dd:hh:mm:ss');

    if (date <= currentDate.unix()) {
      formattedCountdown = moment
        .duration(moment.duration(currentDate.diff(currentDate)))
        .format('dd:hh:mm:ss');
      clearInterval(window.interval);
    }

    setTimeLeft(formattedCountdown);
  };

  React.useEffect(() => {
    window.interval = setInterval(() => {
      calculateTime();
    }, 1000);
    return () => clearInterval(window.interval);
  }, []);

  React.useEffect(() => {
    calculateTime();
  }, [date]);

  React.useEffect(() => {
    updatedDate &&
      handleDeeplink(
        timer.action.deep_link,
        timer.action.apiType,
        updatedDate
      ).then((response) => {
        response && response.date && setDate(response.date);
        setUpdatedDate();
      });
  }, [updatedDate]);

  const dividers = () => {
    const divider = [];
    for (let i = 1; i < get(stage, 'totalStages', 0); i++) {
      divider.push(
        <Divider
          orientation="vertical"
          style={{
            width: 3,
            position: 'absolute',
            left: `${(100 / stage.totalStages) * i}%`,
            top: 0,
            backgroundColor: 'white',
          }}
        />
      );
    }
    return divider;
  };

  React.useEffect(() => {
    setProgressBoxWidth(progressBoxRef.current.getBoundingClientRect().width);
  }, [props]);

  return (
    <Box
      p={3}
      style={{
        borderRadius: 10,
        boxShadow: '0px 2.5px 20px #0000002d',
        backgroundColor: '#ffffff',
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Box>
          <Typography
            variant="h5"
            style={{ fontWeight: 700, color: '#505050', lineHeight: 1 }}
          >
            {title}
          </Typography>
          <Typography style={{ color: '#505050' }}>{subtitle}</Typography>
        </Box>
        {/* {timer&&<Box display='flex' alignItems='center'>
          <DynamicIcon iconId={timer.iconId} style={{ marginRight: 16 }} />
          <Typography
            variant='h5'
            align='center'
            style={{
              fontWeight: 700,
              color: '#505050',
              marginRight: 8,
              width: 140
            }}
          >
            {timeLeft}
          </Typography>
          {timer.action && (
            <>
              <IconButton onClick={() => setOpen(!open)} ref={buttonRef}>
                <DynamicIcon iconId={timer.action.iconId} />
              </IconButton>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <DatePicker
                  variant='inline'
                  value={moment.unix(date)}
                  open={open}
                  onClose={() => {
                    setOpen(false)
                  }}
                  onChange={(changedDate) => {
                    if (moment.unix(date).format('M:D:YYYY') !== changedDate.format('M:D:YYYY')) {
                      changedDate = changedDate.set({hour: 23, minute: 59, second: 59})
                      setUpdatedDate({[timer.key]: changedDate.unix()})
                    }
                  }}
                  maxDate={moment().add(1, 'M')}
                  PopoverProps={{ anchorEl: buttonRef.current }}
                  TextFieldComponent={() => null}
                  autoOk
                  disablePast
                />
              </MuiPickersUtilsProvider>
            </>
          )}
        </Box>} */}
      </Box>
      <Box pt={3}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb="12px"
        >
          <Typography
            style={{
              fontSize: 12,
              color: '#505050',
              marginRight: 24,
            }}
          >
            {stage.title}
          </Typography>
          <Typography
            style={{
              fontSize: 12,
              color: '#505050',
            }}
          >
            100%
          </Typography>
        </Box>
        <Box
          width="100%"
          borderRadius="5px"
          height={16}
          position="relative"
          mb="34px"
          style={{ backgroundColor: '#F7F7F7' }}
        >
          <Box
            borderRadius="5px"
            height="100%"
            position="relative"
            width={`${stage.progress}%`}
            style={{
              background: getGradient(stage.gradientId),
            }}
          >
            <Box
              ref={progressBoxRef}
              position="absolute"
              right={`-${progressBoxWidth / 2}px`}
              top="170%"
              style={{
                padding: '4px 8px',
                background: getGradient(stage.progressGradientId),
                borderRadius: 3,
                color: 'white',
              }}
            >
              <Box
                style={{
                  position: 'absolute',
                  left: 'calc(50% - 3px)',
                  content: '""',
                  borderBottom: '3px solid #7467F0',
                  borderLeft: '3px solid transparent',
                  borderRight: '3px solid transparent',
                  bottom: '100%',
                }}
              />
              <Typography
                style={{ fontSize: 10 }}
              >{`${stage.progress}%`}</Typography>
            </Box>
          </Box>
          {dividers()}
        </Box>
      </Box>
    </Box>
  );
};

export function TextInputWidgetLarge({
  title,
  description,
  maxLength,
  inputAllowed,
  text,
  _key,
  setFormState,
  formData,
  deep_link,
}) {
  const [editableState, setEditableState] = React.useState(false);
  let inputFieldRef = React.useRef();

  React.useEffect(() => {
    inputFieldRef.current.focus();
  }, [editableState]);

  React.useEffect(() => {
    text && setFormState({ [_key]: text });
  }, [text]);

  return (
    <div
      style={{
        padding: '20px 30px 20px 30px',
        minWidth: '25vw',
        maxWidth: '100%',
        marginTop: 15,
        border: '1px solid #dddddd',
      }}
    >
      <Typography variant="h6" style={{ fontWeight: 'bold', color: '#909090' }}>
        {title}
      </Typography>
      <FormControl size="small" fullWidth>
        <InputLabel id={_key}>
          {!(formData[_key] || text) && description}
        </InputLabel>
        <Box
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <TextField
            inputRef={inputFieldRef}
            size="small"
            disabled={!editableState}
            value={formData[_key] || text}
            style={{ marginTop: 15 }}
            onChange={(event) => setFormState({ [_key]: event.target.value })}
            autoFocus
            inputProps={{
              maxLength: maxLength,
            }}
            helperText={
              ![3, 4, 7].includes(inputAllowed) &&
              maxLength &&
              `${(formData[_key] || text || '').length}/${maxLength}`
            }
            multiline
            fullWidth
            onBlur={() => setEditableState(false)}
            onKeyPress={(e) => {
              const regex = /^[0-9.]+$/;
              if ([3, 4, 7].includes(inputAllowed) && !regex.test(e.key)) {
                e.preventDefault();
              }
            }}
          />
          {!editableState && (
            <IconButton
              onClick={() => {
                setEditableState(true);
              }}
            >
              <DynamicIcon iconId={149} />
            </IconButton>
          )}
        </Box>
      </FormControl>
    </div>
  );
}

export function ChipActionWidget({
  title,
  hours,
  multiselect,
  options,
  selected,
  _key,
  setFormState,
  formData,
  deep_link,
  apiType,
  ...props
}) {
  // const [value, setValue] = React.useState(selected || '');
  // React.useEffect(
  //   () => setFormState(_key, value),
  //   [setFormState, _key, value]
  // );
  React.useEffect(() => {
    selected && setFormState({ [_key]: selected || (multiselect ? [] : '') });
  }, [selected]);

  const handleChange = (value) => {
    const formBody = {
      [_key]: multiselect
        ? [...(formData[_key] || selected || []), value]
        : value,
    };
    setFormState(formBody, deep_link, apiType);
  };

  const unselectItem = (value) => {
    const formBody = {
      [_key]: (formData[_key] || selected || []).filter(
        (item) => item !== value
      ),
    };
    setFormState(formBody, deep_link, apiType);
  };

  const clickHandler = (value) => {
    return multiselect
      ? (formData[_key] || selected || []).includes(value)
        ? () => unselectItem(value)
        : () => handleChange(value)
      : () => handleChange(value);
  };

  return (
    <div style={{ padding: '10px' }}>
      <Box p={1}>
        <Box
          pb={1}
          display="flex"
          justifyContent={hours ? 'space-between' : 'flex-start'}
          alignItems="center"
        >
          <Typography
            style={{
              color: '#585858',
              fontSize: '18px',
            }}
          >
            {title}
          </Typography>
          {hours && (
            <Typography style={{ color: '#787878', fontSize: '1.1rem' }}>
              {hours}
            </Typography>
          )}
        </Box>
        <Box display="flex" justifyContent={'flex-start'} alignItems="center">
          {(options || []).map((item, index) => (
            <div style={{ padding: '5px 10px 5px 0px' }}>
              <Button
                variant="outlined"
                onClick={clickHandler(item.id)}
                style={{
                  ...((
                    multiselect
                      ? (formData[_key] || selected || []).includes(item.id)
                      : item.id === formData[_key] || selected
                  )
                    ? {
                        backgroundColor: props.selectedColor || '#000000',
                        color: '#ffffff',
                        border: 'none',
                      }
                    : { backgroundColor: '#ffffff', color: '#686868' }),
                }}
              >
                {item.title}
              </Button>
            </div>
          ))}
        </Box>
      </Box>
    </div>
  );
}

export function ChipSelectionInputWidget({
  title,
  chips,
  hint,
  selected,
  multipleSelect,
  _key,
  setFormState,
  maxSelectionLimit,
  formData,
}) {
  React.useEffect(() => {
    setFormState({ [_key]: selected });
  }, [selected]);

  const isListedOption = (chip) => {
    return !!chips.find((currentChip) => currentChip.id === chip.id);
  };

  const handleTextInput = (chip) => {
    const customChipPresetImage = chips.find(
      (currentChip) => currentChip.title === chip.title
    );
    let tempFormState = [...(formData[_key] || selected)];

    if (customChipPresetImage) {
      setFormState({
        [_key]: multipleSelect
          ? [
              ...(isListedOption((formData[_key] || selected)[0])
                ? formData[_key] || selected
                : (formData[_key] || selected).slice(1)),
              customChipPresetImage,
            ]
          : [customChipPresetImage],
      });
    } else {
      setFormState({
        [_key]: multipleSelect
          ? [
              chip,
              ...(isListedOption((formData[_key] || selected)[0])
                ? formData[_key] || selected
                : (formData[_key] || selected).slice(1)),
            ]
          : [chip],
      });
    }
  };

  // const emptyFieldBackSpaceHandler = ({ nativeEvent }) => {
  //   if (
  //     nativeEvent.key === 'Backspace' &&
  //     (!multipleSelect ||
  //       ((formData[_key] || selected || []).length > 1 &&
  //         (
  //           (((formData || {})[_key] || [])[0] !== undefined
  //             ? ((formData || {})[_key] || [])[0]
  //             : (selected || [])[0] !== undefined
  //             ? (selected || [])[0]
  //             : '') || ''
  //         ).length === 0))
  //   ) {
  //     setFormState({
  //       [_key]:
  //         (formData[_key] || selected || []).length > 1
  //           ? (formData[_key] || selected || []).slice(
  //               0,
  //               (formData[_key] || selected || []).length - 1
  //             )
  //           : [],
  //     });
  //   }
  // };

  return (
    <div
      style={{
        padding: '20px',
        border: '1px solid #c4c4c4',
        borderRadius: 6,
        margin: '15px 10px',
      }}
    >
      <Typography
        style={{
          color: '#909090',
          paddingLeft: 5,
          paddingRight: 5,
          fontSize: 16,
          fontWeight: 'bold',
        }}
      >
        {title}
      </Typography>
      <div style={{ paddingLeft: 5, paddingRight: 5 }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            flexWrap: 'wrap',
            maxWidth: '100%',
            marginBottom: 20,
            borderBottom: '1px solid #e8e8e8',
            paddingTop: 10,
            paddingBottom: 10,
          }}
        >
          {(formData[_key] || selected || [])
            .filter(isListedOption)
            .map((chip) => (
              <div
                style={{
                  paddingTop: 4,
                  paddingBottom: 4,
                  paddingLeft: 8,
                  paddingRight: 8,
                  borderRadius: 5,
                  background: `#dce7ff`,
                  marginHorizontal: 5,
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginRight: 5,
                }}
              >
                <Typography
                  style={{
                    textAlign: 'left',
                    color: '#000000',
                  }}
                >
                  {chip.title}
                </Typography>
                <button
                  style={{
                    cursor: 'pointer',
                    border: 'none',
                    background: 'none',
                    outline: 'none',
                  }}
                  onClick={() =>
                    setFormState({
                      [_key]: (formData[_key] || selected).filter(
                        (currentChip) => currentChip.id !== chip.id
                      ),
                    })
                  }
                >
                  <CancelOutlined
                    style={{
                      fontSize: 18,
                      marginLeft: 5,
                      marginRight: -7,
                      color: '#777b9f',
                    }}
                  />
                </button>
              </div>
            ))}
          <TextField
            {...{
              ...{
                value: isListedOption(
                  (formData[_key] || selected || [])[0] || {}
                )
                  ? ''
                  : ((formData[_key] || selected || [])[0] || {}).title,
                placeholder:
                  (formData[_key] || selected || []).filter(
                    (item) => item.title !== ''
                  ).length < 1
                    ? hint
                    : '',
                onChange: (e) =>
                  handleTextInput({ id: 'new_chip', title: e.target.value }),
              },
            }}
            fullWidth
            InputProps={{
              disableUnderline: true,
            }}
          />
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-start',
          flexWrap: 'wrap',
        }}
      >
        {chips.map((chip) => (
          <button
            onClick={
              (formData[_key] || selected || []).includes(chip)
                ? () =>
                    setFormState({
                      [_key]: (formData[_key] || selected).filter(
                        (currentChip) => currentChip !== chip
                      ),
                    })
                : multipleSelect
                ? () =>
                    setFormState({
                      [_key]: [...(formData[_key] || selected), chip],
                    })
                : () => setFormState({ [_key]: [chip] })
            }
            style={{
              marginRight: 5,
              marginLeft: 5,
              paddingTop: 4,
              paddingBottom: 4,
              paddingLeft: 8,
              paddingRight: 8,
              border: (formData[_key] || selected || []).find(
                (currentChip) => currentChip.id === chip.id
              )
                ? `1px solid #3d65fe`
                : `none`,
              outline: 'none',
              cursor: 'pointer',
              borderRadius: 5,
              background: '#dce7ff',
              marginHorizontal: 5,
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginTop: 5,
            }}
          >
            {(formData[_key] || selected || []).find(
              (currentChip) => currentChip.id === chip.id
            ) && (
              <CheckCircleOutline
                style={{ fontSize: 18, marginRight: 5, color: '#777b9f' }}
              />
            )}
            <Typography
              style={{
                textAlign: 'left',
                color: '#000000',
              }}
            >
              {chip.title}
            </Typography>
          </button>
        ))}
      </div>
    </div>
  );
}

export function NestedDropdownWidget({
  title,
  selection,
  selected,
  _key,
  subSelectionKey,
  setFormState,
  formData,
}) {
  const [anchorElement, setAnchorElement] = React.useState();
  const [open, setOpen] = React.useState(false);
  const [subSelection, setSubSelection] = React.useState(undefined);
  const [localLevel1Selected, setLocalLevel1Selected] = React.useState('');

  React.useEffect(() => {
    selected &&
      setFormState({
        ...(_key ? { [_key]: selected } : {}),
        [subSelectionKey]: (
          (selection || []).find((menuItem) => menuItem.id === selected) || {}
        ).selected,
      });
    selected &&
      setSubSelection(
        ((selection || []).find((menuItem) => menuItem.id === selected) || {})
          .subSelection
      );
  }, [selected]);

  return (
    <div style={{ padding: 0, marginTop: 20 }}>
      <div
        style={{
          padding: '18.5px 14px 18.5px 14px',
          // borderRadius: 4,
          border: '1px solid #0000003b',
          cursor: 'pointer',
        }}
      >
        <div
          onClick={(event) => {
            setAnchorElement(event.target);
            setOpen(true);
          }}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          {!(formData[_key] || formData[subSelectionKey]) && (
            <div style={{ color: '#909090', fontSize: '1rem' }}>{title}</div>
          )}
          <div
            style={{
              fontSize: '1rem',
            }}
          >
            {formData[_key] &&
              (
                selection.find((menuItem) => menuItem.id === formData[_key]) ||
                {}
              ).title}
            {formData[_key] && formData[subSelectionKey] && ' > '}
            {formData[subSelectionKey] &&
              (
                subSelection.find(
                  (subMenuItem) => subMenuItem.id === formData[subSelectionKey]
                ) || {}
              ).title}
          </div>
          <KeyboardArrowDown style={{ color: '#909090', marginTop: 1 }} />
        </div>
        <Popover
          anchorEl={anchorElement}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          open={open}
          onClose={() => {
            setOpen(false);
          }}
          PaperProps={{
            style: {
              padding: '10px 0px 10px 0px',
              boxShadow: '0px 2.5px 20px #0000002d',
            },
          }}
        >
          <div style={{ display: 'flex', flex: 1, width: '100%' }}>
            <div>
              {selection.map((menuItem) => (
                <div
                  style={{
                    padding: '5px 15px 5px 15px',
                    ...((formData[_key] || localLevel1Selected) === menuItem.id
                      ? {
                          background: '#e8e8e8',
                          borderRight: '3px solid #7467F0',
                        }
                      : { background: '#ffffff', border: 'none' }),
                    minWidth: 200,
                    cursor: 'pointer',
                    fontSize: '1rem',
                    color: '#505050',
                  }}
                  onClick={() => {
                    _key !== undefined
                      ? setFormState({
                          [_key]: menuItem.id,
                          [subSelectionKey]: undefined,
                        })
                      : setLocalLevel1Selected(menuItem.id);
                    setSubSelection(menuItem.subSelection);
                  }}
                >
                  {menuItem.title}
                </div>
              ))}
            </div>
            {subSelection && (
              <div
                style={{
                  borderLeft: '1px solid #e0e0e0',
                }}
              >
                {subSelection.map((subMenuItem) => (
                  <div
                    style={{
                      padding: '5px 15px 5px 15px',
                      background:
                        formData[subSelectionKey] === subMenuItem.id
                          ? '#e8e8e8'
                          : '#ffffff',
                      minWidth: 200,
                      cursor: 'pointer',
                      fontSize: '1rem',
                      color: '#505050',
                    }}
                    onClick={() => {
                      setFormState({ [subSelectionKey]: subMenuItem.id });
                    }}
                  >
                    {subMenuItem.title}
                  </div>
                ))}
              </div>
            )}
          </div>
        </Popover>
      </div>
    </div>
  );
}

export function MultipleTextInput({
  multiselect,
  formData = [],
  _key,
  description,
  title,
  setFormState,
  fields,
}) {
  React.useEffect(() => {
    fields.reduce(
      (formData, currentField) => ({
        ...formData,
        [currentField.key]: currentField.text,
      }),
      {}
    ) &&
      setFormState(
        fields.reduce(
          (formData, currentField) => ({
            ...formData,
            [currentField.key]: currentField.text,
          }),
          {}
        )
      );
  }, [fields]);

  return (
    <div
      style={{
        padding: '20px 40px 20px 40px',
        minWidth: '25vw',
        maxWidth: '100%',
        border: '1px solid #dddddd',
        marginTop: 15,
      }}
    >
      <Typography variant="h6" style={{ fontWeight: 'bold', color: '#909090' }}>
        {title}
      </Typography>
      <div
        style={{
          display: 'flex',
          alignItems: 'baseline',
          justifyContent: 'space-between',
          marginTop: 15,
        }}
      >
        {fields.map((field) => (
          <>
            {field.prefix && (
              <Typography style={{ color: '#909090' }}>
                {field.prefix}
              </Typography>
            )}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-around',
                alignItems: 'baseline',
                width: '35%',
                maxWidth: '40%',
              }}
            >
              <TextField
                id="standard-basic"
                fullWidth
                size="small"
                variant="outlined"
                placeholder={field.hint}
                inputProps={{
                  maxLength: field.maxLength,
                }}
                helperText={
                  ![3, 4, 7].includes(field.inputAllowed) &&
                  field.maxLength &&
                  `${(formData[field.key] || field.text || '').length}/${
                    field.maxLength
                  }`
                }
                onChange={(e) =>
                  setFormState({
                    [field.key]: textFieldInputParser(
                      e.target.value,
                      field.inputAllowed
                    ),
                  })
                }
                onKeyPress={(e) => {
                  const regex = /^[0-9.]+$/;
                  if (
                    [3, 4, 7].includes(field.inputAllowed) &&
                    !regex.test(e.key)
                  ) {
                    e.preventDefault();
                  }
                }}
              />
            </div>
            {field.suffix && (
              <Typography style={{ color: '#909090' }}>
                {field.suffix}
              </Typography>
            )}
          </>
        ))}
      </div>
    </div>
  );
}

export function ExtensibleFormWidget({
  heading,
  border,
  subHeading,
  dialogUtils,
  formData,
  ...props
}) {
  const classes = useStyles();
  const {
    deep_link,
    apiType,
    handleDeeplink,
    setDeepLink,
    overrideHandleDeepLink,
  } = props;
  heading = heading || props.title;
  subHeading = subHeading || props.subtitle;
  // console.log(deep_link, (overrideHandleDeepLink ? setDeepLink : handleDeeplink))

  return (
    <Box
      p={1}
      style={{
        padding: '18.5px 14px 16.5px 14px',
        // borderRadius: 4,
        border: '1px solid #0000003b',
        cursor: 'pointer',
        borderRadius: 5,
        margin: 10,
      }}
      onClick={() =>
        deep_link &&
        handleDeeplink(deep_link, undefined, props, {
          fallbackOperation: setDeepLink,
          doneCallback: (extendedFormData, removableParams) => {
            handleDeeplink(
              deep_link.replace('/location_picker', ''),
              apiType,
              { ...(formData || {}), ...(extendedFormData || {}) },
              {
                errorCallback: (error) => {},
                doneCallback: () => {},
              }
            ).then((response) =>
              (dialogUtils
                ? dialogUtils.current.onDone
                : overrideHandleDeepLink || !apiType || apiType === 1
                ? setDeepLink
                : handleDeeplink)(response.refreshDeeplink)
            );
          },
          errorCallback: (error) => {},
        })
      }
    >
      <Typography
        style={{
          textOverflow: 'ellipsis',
          maxWidth: 'calc(100% - 20px)',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          fontSize: '1rem',
          color: '#909090',
        }}
      >
        {heading}
      </Typography>
      {subHeading && <Typography variant="subtitle1">{subHeading}</Typography>}
    </Box>
  );
}

const SubSelectionFieldRenderer = ({
  subSelectionContent = [],
  blockIndex,
  ...props
}) => {
  return subSelectionContent.map((contentBlock) => (
    <div style={{ padding: 10, position: 'relative' }}>
      {(contentBlock.content || {}).title && (
        <div
          style={{
            position: 'absolute',
            zIndex: 100,
            background: '#ffffff',
            opacity: 1,
            top: -10,
            left: 30,
            padding: 5,
          }}
        >
          <Typography style={{ color: '#505050', fontSize: 17.5 }}>
            {(contentBlock.content || {}).title}
          </Typography>
        </div>
      )}
      <div
        style={{
          flex: 1,
          border: '1px solid #848484',
          borderRadius: 4,
          fontSize: '1rem',
          padding: '18.5px 14px',
          color: '#909090',
        }}
      >
        {(contentBlock.cards || []).map((card) => (
          <div>
            {((card || {}).content || []).map((field) => (
              <CardWidget
                {...{
                  ...props,
                  ...field,
                  _key: `${field.key}_${blockIndex}`,
                }}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  ));
};

const FieldBlock = ({ rawFieldBlock, blockIndex, ...props }) => {
  const [subSelectionIndices, setSubSelectionIndices] = React.useState([]);
  const [fieldBlock, setFieldBlock] = React.useState(rawFieldBlock || []);

  const overrideInterpolateSelctions = (subSelectionCards, index) => {
    if (!!subSelectionCards) {
      setSubSelectionIndices([...subSelectionIndices, index + 1]);
      setFieldBlock([
        ...(fieldBlock.slice(0, index + 1) || []),
        subSelectionCards,
        ...fieldBlock.slice(index + 1),
      ]);
    } else {
      setFieldBlock([
        ...(fieldBlock.slice(0, index + 1) || []),
        ...fieldBlock.slice(index + 2),
      ]);
    }
  };

  return (
    <Box
      style={{
        position: 'relative',
        margin: '5px',
        overflow: 'visible',
      }}
    >
      <Card
        style={{
          flex: 1,
          borderRadius: 4,
          fontSize: '1rem',
          padding: '10px',
          cursor: 'pointer',
          color: '#909090',
          boxShadow: '0px 2.5px 20px #0000002d',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-end',
            padding: '5px 10px',
          }}
        >
          <Typography
            style={{ color: '#505050', fontSize: 20, fontWeight: 'bold' }}
          >{`Form Field - ${blockIndex + 1}`}</Typography>
        </div>
        {fieldBlock.map((field, index) =>
          subSelectionIndices.includes(index) ? (
            <SubSelectionFieldRenderer
              {...{
                ...props,
                subSelectionContent: field,
                blockIndex,
                interpolateSections: (subSelectionCards) =>
                  overrideInterpolateSelctions(subSelectionCards, index),
              }}
            />
          ) : (
            <CardWidget
              {...{
                ...props,
                ...field,
                interpolateSections: (subSelectionCards) =>
                  overrideInterpolateSelctions(subSelectionCards, index),
              }}
            />
          )
        )}
      </Card>
    </Box>
  );
};

export function CardTemplateFormWidget({
  button,
  fieldSet,
  values,
  setFormState,
  ...props
}) {
  const [fieldCount, setFieldCount] = React.useState(1);
  const [fieldBlocks, setFieldBlocks] = React.useState([]);

  React.useEffect(() => {
    const state = (values || []).reduce(
      (state, currentBlock) => ({
        ...state,
        ...Object.keys(currentBlock || {}).reduce(
          (fieldState, currentField) => ({
            ...fieldState,
            [currentField]: currentBlock[currentField],
          }),
          {}
        ),
      }),
      {}
    );
    setFormState({ ...(state || {}) });
  }, [values]);

  React.useEffect(() => {
    setFieldBlocks([
      ...fieldBlocks,
      fieldSet.map((field) => ({
        ...field,
        key: `${field.key}_${fieldCount}`,
        _key: `${field.key}_${fieldCount}`,
      })),
    ]);
  }, [fieldCount]);

  return (
    <div style={{ position: 'relative' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-end',
          padding: 10,
        }}
      >
        <Typography
          style={{ fontSize: 24, color: '#505050', fontWeight: 'bold' }}
        >
          Form Fields
        </Typography>
        <div style={{ flex: 1, borderBottom: '1px solid #a5a5a5' }} />
      </div>
      <div
        style={{
          flex: 1,
          // border: '1px solid #848484',
          borderRadius: 4,
          fontSize: '1rem',
          padding: 10,
          color: '#909090',
        }}
      >
        {fieldBlocks.map((fieldBlock, index) => (
          <FieldBlock
            {...{
              ...props,
              rawFieldBlock: fieldBlock,
              setFormState,
              blockIndex: index,
            }}
          />
        ))}
        {button && (
          <Button
            onClick={() => setFieldCount(fieldCount + 1)}
            style={{
              border: '1px solid #848484',
              color: '#848484',
              margin: '20px 5px',
            }}
          >
            <DynamicIcon iconId={button.iconId} />
            <Typography style={{ color: '#848484' }}>{button.title}</Typography>
          </Button>
        )}
      </div>
    </div>
  );
}

export function CheckboxInputWidget({
  selectedValue,
  title,
  _key,
  setFormState,
  formData,
}) {
  const classes = useStyles();
  React.useEffect(() => {
    setFormState({ [_key]: selectedValue || false });
  }, [selectedValue]);

  return (
    <div style={{ margin: '10px' }}>
      <div
        className={classes.borderedField}
        style={{
          display: 'flex',
          alignItems: 'center',
          maxWidth: '100%',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          margin: 0,
          padding: 0,
        }}
      >
        <Checkbox
          style={{ height: 25, width: 25, marginRight: 10 }}
          checked={formData[_key] || false}
          onClick={() => setFormState({ [_key]: !formData[_key] })}
          color="primary"
        />
        <Typography
          style={{ maxWidth: '100%', textOverflow: 'ellipsis' }}
          noWrap
        >
          {title}
        </Typography>
      </div>
    </div>
  );
}

const TableShimmer = () => {
  const classes = useStyles();
  const shimmers = () => {
    let rows = [];
    for (let i = 0; i < 20; i++) {
      rows.push(
        <>
          <Typography
            component="div"
            key={1}
            variant="h2"
            style={{ width: '100%' }}
          >
            <Skeleton
              className={classes.root}
              animation="wave"
              width="100%"
            ></Skeleton>
          </Typography>
        </>
      );
    }
    return rows;
  };

  return <div style={{ width: '100%', overflowY: 'hidden' }}>{shimmers()}</div>;
};

export const ProductSearchWithCartWidget = ({
  searchData,
  searchDeeplink,
  bulkOrderDeeplink,
  ...props
}) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [searchError, setSearchError] = React.useState(false);
  function useDebounce(callback, delay) {
    const debouncedFn = React.useCallback(
      debounce((...args) => callback(...args), delay),
      [delay] // will recreate if delay changes
    );
    return debouncedFn;
  }
  const fileInputRef = React.useRef({});

  const handleClick = (event) => {
    if (localSearchString) {
      searchError && setSearchError(false);
      setSearchString(localSearchString);
    } else {
      setSearchError(true);
      searchBar.current.focus();
    }
  };
  const searchBar = React.useRef({});

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [localSearchString, setLocalSearchString] = React.useState('');
  const [searchString, setSearchString] = React.useState('');
  const [showPrice, setShowPrice] = React.useState(false);
  const open = Boolean(anchorEl);
  const id = open ? 'transitions-popper' : undefined;
  const [loading, setLoading] = React.useState(false);

  const [localFilters, setLocalFilters] = React.useState({});
  const [selectedFilters, setSelectedFilters] = React.useState({});
  const [searchResults, setSearchResults] = React.useState([]);
  const [cartItems, setCartItems] = React.useState();
  const [cartPrice, setCartPrice] = React.useState(0);
  const [showTitle, setShowTitle] = React.useState(true);
  const [responseAwaited, setResponseAwaited] = React.useState(false);
  const shrink = !!localSearchString;

  const debouncedSearch = useDebounce((nextValue) => {
    setSearchString(nextValue);
  }, 500);

  const handleChange = (event) => {
    event.persist();
    const { value: nextValue } = event.target;
    setLocalSearchString(nextValue);
    debouncedSearch(nextValue);
  };
  const handleChangeQty = (formState, setFormState, item, value) => {
    setFormState(() => {
      let remaining = formState.filter((current) => current.id !== item.id);
      let updatedState = [...remaining];
      let currentItem = {
        ...item,
        cartQty: parseInt(value),
      };
      return [...updatedState, { ...currentItem }];
    });
    debouncedUpdate(item, value);
    !value && setResponseAwaited(item.id);
  };
  const getItemValue = (formState, item) => {
    let current = formState.find((element) => element.id === item.id);
    return (current && current.cartQty) || 0;
  };

  React.useEffect(() => {
    if (props.filters) {
      let currentFilters = {};
      props.filters.forEach((filter) => {
        if (
          !!filter.selected &&
          filter.selected != selectedFilters[filter.key]
        ) {
          currentFilters[filter.key] = filter.selected;
        }
      });
      Object.keys(currentFilters).length > 0 &&
        setSelectedFilters({ ...currentFilters });
    }
  }, [props.filters]);

  React.useEffect(() => {
    selectedFilters &&
      Object.keys(selectedFilters).length > 0 &&
      setLocalFilters({ ...selectedFilters });
  }, [selectedFilters]);

  const debouncedUpdate = useDebounce((item, value) => {
    updateItemQuanitity(item, value);
  }, 600);

  const updateItemQuanitity = (item, value) => {
    if (value === 0 || !!value) {
      let itemToUpdate = {};
      itemToUpdate[item.id] = value;
      item.updateAction &&
        props
          .handleDeeplink(
            item.updateAction.deeplink,
            item.updateAction.apiType || 2,
            itemToUpdate
          )
          .then((response) => {
            if (response) {
              response.refreshDeeplink &&
                props
                  .handleDeeplink(response.refreshDeeplink)
                  .then((response) => {
                    setResponseAwaited(-1);
                    if (response) {
                      response.items && setCartItems(response.items);
                      response.totalAmount &&
                        setCartPrice(response.totalAmount);
                      response.userMessage &&
                        props.setMessage(response.userMessage);
                    }
                  });
              response.userMessage && props.setMessage(response.userMessage);
            }
          });
    }
  };
  const addToCart = (item) => {
    let itemToAdd = {};
    itemToAdd[item.id] = 1;
    props
      .handleDeeplink(
        props.addToCartDeeplink.deeplink,
        props.addToCartDeeplink.apiType || 2,
        itemToAdd
      )
      .then((response) => {
        if (response) {
          response.refreshDeeplink &&
            props.handleDeeplink(response.refreshDeeplink).then((response) => {
              setResponseAwaited(-1);
              if (response) {
                response.items && setCartItems(response.items);
                response.totalAmount && setCartPrice(response.totalAmount);
                response.userMessage && props.setMessage(response.userMessage);
              }
            });
          response.userMessage && props.setMessage(response.userMessage);
        }
      });
  };
  const removeFilter = (filter) => {
    let res = {};
    for (let key in localFilters) {
      if (key != filter.key) res[key] = localFilters[key];
    }
    setLocalFilters({ ...res });
    Object.keys(selectedFilters).length > 0 && setSelectedFilters({ ...res });
  };

  React.useEffect(() => {
    setLoading(true);
    searchString || searchString == ''
      ? props
          .handleDeeplink(
            `/${
              searchDeeplink.deeplink
            }/query/search/${searchString}${Object.keys(
              selectedFilters || {}
            ).reduce(
              (queryString, currentFilter) =>
                queryString +
                `/${currentFilter}/${selectedFilters[currentFilter]}`,
              ''
            )}`
          )
          .then((response) => {
            setLoading(false);
            !!searchString ? setShowTitle(false) : setShowTitle(true);
            if (response) {
              response.searchResults &&
                setSearchResults(response.searchResults);
              response.showPrice && setShowPrice(response.showPrice);
            }
            setAnchorEl(searchBar.current);
            searchBar.current && searchBar.current.focus();
          })
      : setAnchorEl(null);
  }, [searchString, selectedFilters]);
  React.useEffect(() => {
    props.cartDeeplink &&
      props.handleDeeplink(props.cartDeeplink.deeplink).then((response) => {
        response && response.items && setCartItems(response.items);
        response.totalAmount && setCartPrice(response.totalAmount);
      });
  }, [props.cartDeeplink]);

  return (
    <div style={{ display: 'flex' }}>
      <div
        style={{
          padding: '0px 20px 0px 30px',
          width: '70%',
          position: 'relative',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: 10,
            paddingTop: 12,
            justifyContent: 'space-between',
          }}
        >
          <input
            type="file"
            accept=".xlsx, .csv, .xls"
            style={{ display: 'none' }}
            ref={fileInputRef}
          />
          <div>
            <Typography style={{ fontSize: 28, fontWeight: 'bold' }}>
              Place Your Order
            </Typography>
          </div>
          <div>
            {bulkOrderDeeplink && bulkOrderDeeplink.deeplink && (
              <Button
                variant="contained"
                style={{
                  marginLeft: 10,
                  background: '#00b08c',
                  color: '#ffffff',
                  paddingLeft: 18,
                  paddingRight: 18,
                  height: 40,
                  maxWidth: 250,
                  borderRadius: 5,
                }}
                onClick={() => {
                  props.handleDeeplink(
                    bulkOrderDeeplink.deeplink,
                    bulkOrderDeeplink.apiType || 2,
                    {},
                    {
                      doneCallback: (refreshDeeplink) =>
                        props.setDeepLink(refreshDeeplink),
                    },
                    {
                      refresh: (refreshDeeplink) =>
                        props.setDeepLink(refreshDeeplink),
                      columns: bulkOrderDeeplink.columns,
                      fileInputRef,
                    }
                  );
                }}
              >
                <DynamicIcon
                  iconId={936}
                  insideColoredButton
                  style={{
                    height: 20,
                    width: 20,
                    color: '#ffffff',
                    marginLeft: 5,
                  }}
                />
                <div
                  style={{
                    fontWeight: 'bold',
                    whiteSpace: 'nowrap',
                    marginLeft: 5,
                    marginRight: 5,
                    color: '#ffffff',
                    fontSize: 15,
                  }}
                >
                  Bulk Order
                </div>
              </Button>
            )}
            {props.exampleSheetLink && props.exampleSheetLink.deeplink && (
              <Tooltip
                title={'Download Template'}
                classes={{
                  tooltip: classes.tooltip,
                }}
              >
                <IconButton
                  onClick={() => {
                    props
                      .handleDeeplink(
                        props.exampleSheetLink.deeplink,
                        props.exampleSheetLink.apiType || 1
                      )
                      .then((response) => {
                        if (response) {
                          /^(http|https):\/\/(.+)/.test(
                            response.refreshDeeplink ||
                              (response.data || {}).refreshDeeplink ||
                              ''
                          ) &&
                            props.handleDeeplink(
                              response.refreshDeeplink ||
                                (response.data || {}).refreshDeeplink
                            );
                        }
                      });
                  }}
                  style={{
                    backgroundColor: '#00b08c',
                    borderRadius: 5,
                    color: '#ffffff',
                    width: 30,
                    height: 30,
                    marginRight: 5,
                    dilspay: 'flex',
                    alignItems: 'center',
                    padding: 20,
                    marginLeft: 10,
                  }}
                >
                  <DynamicIcon
                    iconId={932}
                    style={{ height: 20, width: 20, color: '#ffffff' }}
                    insideColoredButton={true}
                  />
                </IconButton>
              </Tooltip>
            )}
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            width: '100%',
            alignItems: 'flex-start',
            height: 70,
          }}
        >
          <TextField
            style={{ marginTop: '10px', width: '40%' }}
            autoComplete="off"
            error={searchError && true}
            helperText={searchError && 'Enter a search query'}
            value={localSearchString}
            autoFocus={true}
            size="small"
            inputRef={searchBar}
            fullWidth={true}
            label={props.hint || 'Search Medicine'}
            id="outlined-start-adornment"
            onKeyPress={(e) => {
              if (e.key == 'Enter') {
                handleClick(e);
              }
            }}
            InputLabelProps={{
              style: { height: '40px', left: !shrink && '32px' },
              shrink: shrink,
              className: shrink ? undefined : classes.inputLabelNoShrink,
            }}
            InputProps={{
              style: {
                height: '40px',
                width: '100%',
                background: '#f9f9f9',
              },
              endAdornment: (
                <InputAdornment position="end">
                  {localSearchString && (
                    <IconButton
                      edge="end"
                      onClick={() => {
                        setLocalSearchString('');
                        searchBar.current.focus();
                        setSearchString('');
                      }}
                    >
                      {<CloseOutlined />}
                    </IconButton>
                  )}
                </InputAdornment>
              ),
              startAdornment: (
                <InputAdornment position="start">
                  <SearchOutlined />
                </InputAdornment>
              ),
            }}
            variant="outlined"
            onChange={handleChange}
          />
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'flex-start',
              flexGrow: 1,
              paddingRight: 8,
              paddingLeft: 8,
            }}
          >
            {props.filters && (
              <>
                {props.filters.map((filter) =>
                  filter.type == 'dropdown' ? (
                    <DropdownField
                      removeFilter={removeFilter}
                      localFilters={localFilters}
                      setLocalFilters={setLocalFilters}
                      field={filter}
                      selectedFilters={selectedFilters}
                      setSelectedFilters={setSelectedFilters}
                    />
                  ) : filter.type == 'date' ? (
                    <DateField
                      removeFilter={removeFilter}
                      localFilters={localFilters}
                      setLocalFilters={setLocalFilters}
                      field={filter}
                      selectedFilters={selectedFilters}
                      setSelectedFilters={setSelectedFilters}
                    />
                  ) : null
                )}
                <div
                  style={{
                    width: 40,
                    height: 40,
                    background: '#f9f9f9',
                    margin: 10,
                  }}
                >
                  <Tooltip title="Apply Filters">
                    <IconButton
                      onClick={() => {
                        Object.keys(localFilters).length > 0
                          ? setSelectedFilters({ ...localFilters })
                          : alert('Select atleast one filter!');
                      }}
                      style={{ width: 40, height: 40, background: '#f9f9f9' }}
                    >
                      <DynamicIcon
                        iconId={
                          Object.keys(selectedFilters).length > 0 ? 162 : 160
                        }
                        style={{ height: 20, width: 20 }}
                      />
                    </IconButton>
                  </Tooltip>
                </div>
              </>
            )}
          </div>
        </div>
        {open && (
          <Box
            style={{
              position: 'relative',
              width: '100%',
              maxHeight: `84vh`,
              marginTop: '20px',
            }}
            open={open}
            anchorEl={anchorEl}
            onClose={() => {
              setAnchorEl(null);
              setSearchString('');
              searchBar.current.focus();
            }}
          >
            <div>
              {searchResults.rows && searchResults.rows.length > 0 ? (
                <div>
                  <Typography
                    variant="h6"
                    style={{
                      padding: '5px 0px 5px 0px',
                      fontWeight: 'bold',
                      color: '#413e3e',
                    }}
                  >
                    {searchResults.title ||
                      (showTitle
                        ? 'Frequently Ordered Products'
                        : 'Search Results')}
                  </Typography>
                  <div
                    style={{
                      display: 'flex',
                      width: '100%',
                      height: `calc(100vh - 200px)`,
                      paddingTop: 8,
                    }}
                  >
                    {loading ? (
                      <TableShimmer />
                    ) : (
                      <TabularSearchResults
                        addItem={addToCart}
                        getItemValue={getItemValue}
                        handleChange={handleChangeQty}
                        searchResults={searchResults}
                        setSearchResults={setSearchResults}
                        setMessage={props.setMessage}
                        cartItems={cartItems}
                        setCartItems={setCartItems}
                        cartPrice={cartPrice}
                        setCartPrice={setCartPrice}
                        handleDeeplink={props.handleDeeplink}
                        addToCartDeeplink={props.addToCartDeeplink}
                        responseAwaited={responseAwaited}
                        setResponseAwaited={setResponseAwaited}
                      />
                    )}
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    height: '70vh',
                    background: '#ffffff',
                  }}
                >
                  <img
                    src="https://cdn.dribbble.com/users/760295/screenshots/4433975/no-search-result.png"
                    width="30%"
                  />
                </div>
              )}
            </div>
          </Box>
        )}
      </div>
      <div style={{ width: '30%', paddingLeft: 10 }}>
        <Cart
          calculationParameter={props.calculationParameter || 'ptr'}
          getItemValue={getItemValue}
          handleChange={handleChangeQty}
          setDeepLink={props.setDeepLink}
          items={cartItems}
          setCartItems={setCartItems}
          cartPrice={cartPrice}
          setCartPrice={setCartPrice}
          handleDeeplink={props.handleDeeplink}
          placeOrderDeeplink={props.placeOrderDeeplink}
          setMessage={props.setMessage}
          deleteCartDeeplink={props.deleteCartDeeplink}
        />
      </div>
    </div>
  );
};

export const SearchWidget = (props) => {
  const { deep_link, apiType, _key } = props;
  function useDebounce(callback, delay) {
    const debouncedFn = React.useCallback(
      debounce((...args) => callback(...args), delay),
      [delay]
    );
    return debouncedFn;
  }

  const debouncedSearch = useDebounce((nextValue) => {
    props.setSearchString(nextValue);
  }, 300);

  const handleChange = (event) => {
    event.persist();
    const { value: nextValue } = event.target;
    setLocalSearchString(nextValue);
    debouncedSearch(nextValue);
  };
  const [localSearchString, setLocalSearchString] = React.useState('');
  const [searchError, setSearchError] = React.useState(false);
  const searchBar = React.useRef({});

  React.useEffect(() => {
    if (deep_link) {
      props.setAnchorEl(props.searchResultsContainer.current);
      let searchBody = {};
      searchBody[_key] = props.searchString;
      props.searchString
        ? props
            .handleDeeplink(deep_link, apiType || 1, searchBody)
            .then((response) => {
              if (response) {
                response.searchResults &&
                  props.setSearchResults(response.searchResults);
              }
            })
        : props.setAnchorEl(null);
    }
  }, [props.searchString]);

  React.useEffect(() => {
    props.searchResults &&
      props.setAnchorEl(props.searchResultsContainer.current);
  }, [props.searchResults]);

  configure({
    ignoreTags: ['input', 'select', 'textarea'],
    ignoreEventsCondition: function () {},
  });
  const keyMap = {
    SEARCH: [
      'control+f',
      'control+F',
      'command+f',
      'command+F',
      'ctrl+f',
      'ctrl+F',
    ],
  };

  const handlers = preventDefaultHandlers({
    SEARCH: () => {
      searchBar && searchBar.current && searchBar.current.focus();
      setLocalSearchString('');
      props.setSearchString('');
    },
  });

  React.useEffect(() => {
    props.clearSearchBar && setLocalSearchString('');
    props.clearSearchBar && props.setClearSearchBar(false);
  }, [props.clearSearchBar]);

  return (
    <div style={{ display: 'flex' }}>
      <GlobalHotKeys keyMap={keyMap} handlers={handlers} />
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '25%',
          justifyContent: 'flex-end',
          paddingRight: 32,
        }}
      >
        {props.hint || 'Search'}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', width: '75%' }}>
        <TextField
          autoFocus={true}
          style={{ marginTop: '5px' }}
          autoComplete="off"
          error={searchError && true}
          helperText={searchError && 'Enter a search query'}
          value={localSearchString}
          size="small"
          inputRef={searchBar}
          fullWidth={true}
          label={props.hint || 'Search'}
          id="outlined-start-adornment"
          InputLabelProps={{
            style: { height: '45px', top: '3px' },
          }}
          InputProps={{
            style: {
              height: '45px',
            },
            endAdornment: (
              <InputAdornment position="end">
                {localSearchString && (
                  <IconButton
                    edge="end"
                    onClick={() => {
                      setLocalSearchString('');
                      searchBar.current.focus();
                      props.setSearchString('');
                    }}
                  >
                    {<CloseOutlined />}
                  </IconButton>
                )}
              </InputAdornment>
            ),
          }}
          variant="outlined"
          onChange={handleChange}
        />
      </div>
    </div>
  );
};

export const SearchAndAddWidget = ({
  responseAwaited,
  setResponseAwaited,
  ...props
}) => {
  const { items, presentItems, setPresentItems, fetchContent } = props;
  const classes = useStyles();
  const [searchString, setSearchString] = React.useState('');
  const [clearSearchBar, setClearSearchBar] = React.useState(false);
  const [searchResults, setSearchResults] = React.useState();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [focus, setFocus] = React.useState(undefined);
  // const [responseAwaited, setResponseAwaited] = React.useState(-1);
  const open = Boolean(anchorEl);
  const searchResultsContainer = React.useRef({});
  React.useEffect(() => {
    items &&
      items.billItems &&
      props.handleDeeplink(items.billItems.deep_link).then((response) => {
        response &&
          response.searchResults &&
          setPresentItems({
            columns: [...response.searchResults.columns],
            rows: [...response.searchResults.rows.map((row) => ({ ...row }))],
          });
        response &&
          response.searchResults &&
          setFocus(response.searchResults.focusOn);
      });
  }, [items]);
  const filterKeys = (row, keys) => {
    const filteredRow = Object.keys(row)
      .filter((key) => keys.includes(key))
      .reduce((obj, key) => {
        obj[key] = row[key];
        return obj;
      }, {});
    return filteredRow;
  };

  React.useEffect(() => {
    if (presentItems) {
      let currentItems = presentItems.rows.map((item) =>
        filterKeys(item, [
          'id',
          ...presentItems.columns.map((column) => column.key),
        ])
      );
      let updatedCurrentItems = [...currentItems];
      updatedCurrentItems.forEach((item) => {
        Object.keys(item).forEach((key) => {
          if (
            !!item[key] &&
            typeof item[key] !== 'string' &&
            Object.keys(item[key]).length > 0
          )
            item[key] = item[key].selected;
        });
      });
      props.setFormState({ ['items']: updatedCurrentItems });
    }
  }, [presentItems]);

  function useDebounce(callback, delay) {
    const debouncedFn = React.useCallback(
      debounce((...args) => callback(...args), delay),
      [delay]
    );
    return debouncedFn;
  }

  const addItem = (item, keys) => {
    let itemToAdd = filterKeys(item, ['id', ...keys]);
    item &&
      item.deeplinks &&
      item.deeplinks.add &&
      props
        .handleDeeplink(
          item.deeplinks.add.deep_link,
          item.deeplinks.add.deep_link.apiType || 2,
          { item: itemToAdd }
        )
        .then((response) => {
          if (response) {
            setAnchorEl(null);
            setSearchString('');
            setClearSearchBar(true);
            response.refreshDeeplink && fetchContent(response.refreshDeeplink);
          }
        });
  };

  const clickAction = (item, keys) => {
    item &&
    item.deeplinks &&
    item.deeplinks.clickAction &&
    item.deeplinks.clickAction.deep_link
      ? props
          .handleDeeplink(
            item.deeplinks.clickAction.deep_link,
            item.deeplinks.clickAction.apiType
          )
          .then((response) => {
            if (response) {
              response.searchResults &&
              Object.keys(response.searchResults).length > 0
                ? setSearchResults(response.searchResults)
                : addItem(item, keys);
            }
          })
      : addItem(item, keys);
  };

  const deleteItem = (item) => {
    item &&
      item.deeplinks &&
      item.deeplinks.delete &&
      props
        .handleDeeplink(
          item.deeplinks.delete.deep_link,
          item.deeplinks.delete.deep_link.apiType || 2
        )
        .then((response) => {
          if (response) {
            response.refreshDeeplink && fetchContent(response.refreshDeeplink);
            // setResponseAwaited(-1);
          }
        });
  };
  const generateFormState = (item, _key, nextValue, formData, dataType) => {
    let itemToUpdate = { ...item };
    let updatedState =
      formData && formData.items && formData.items.map((item) => ({ ...item }));
    ((updatedState || []).find((element) => element.id === itemToUpdate.id) ||
      {})[_key] =
      dataType === 1
        ? parseInt(nextValue)
        : dataType === 2
        ? parseFloat(nextValue)
        : nextValue;
    return updatedState;
  };

  const updateItem = (item, _key, nextValue, formData, dataType) => {
    let updatedState = generateFormState(
      item,
      _key,
      nextValue,
      formData,
      dataType
    );

    item &&
      item.deeplinks &&
      item.deeplinks.update &&
      props
        .handleDeeplink(
          item.deeplinks.update.deep_link,
          item.deeplinks.update.deep_link.apiType || 2,
          { ...formData, items: updatedState }
        )
        .then((response) => {
          if (response) {
            response.refreshDeeplink && fetchContent(response.refreshDeeplink);
          }
        });
  };

  const debouncedUpdate = useDebounce(
    (item, _key, nextValue, formData, dataType) => {
      updateItem(item, _key, nextValue, formData, dataType);
    },
    1000
  );

  const handleChange = (item, _key, formData, dataType, nextValue) => {
    let updatedState = generateFormState(
      item,
      _key,
      nextValue,
      formData,
      dataType
    );
    props.setFormState({ ['items']: updatedState });
    debouncedUpdate(item, _key, nextValue, formData, dataType);
  };
  const onKeyPress = (e, dataType) => {
    const regex = /^[0-9.]+$/;
    if ([1, 2].includes(dataType) && !regex.test(e.key)) {
      e.preventDefault();
    }
  };
  const searchBox = React.useRef(null);
  return (
    <>
      <div
        style={{
          display: 'flex',
          width: '100%',
          background: '#ffffff',
          justifyContent: 'flex-end',
        }}
      >
        {items &&
          items.searchFields &&
          items.searchFields.map((searchField, index) => (
            <div style={{ width: '60%', height: '100%' }}>
              <SearchWidget
                handleDeeplink={props.handleDeeplink}
                setAnchorEl={setAnchorEl}
                searchString={searchString}
                setSearchString={setSearchString}
                setSearchResults={setSearchResults}
                searchResults={searchResults}
                searchResultsContainer={searchResultsContainer}
                {...searchField}
                _key={searchField.key}
                clearSearchBar={clearSearchBar}
                setClearSearchBar={setClearSearchBar}
              />
            </div>
          ))}
        <Popper
          ref={searchBox}
          placement="bottom-end"
          style={{
            background: '#ffffff',
            position: 'relative',
            width: searchResultsContainer.current.offsetWidth || '80%',
            maxHeight: '28%',
            overflow: 'auto',
            boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.4)',
            borderRadius: 4,
          }}
          open={open}
          anchorEl={anchorEl}
          onClose={() => {}}
          onClose={() => {
            setAnchorEl(null);
            setSearchString('');
          }}
          className={classes.popper}
          transition
        >
          {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={50}>
              <ClickAwayListener
                onClickAway={() => {
                  setAnchorEl(null);
                  setSearchString('');
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    height: '100%',
                  }}
                >
                  {searchResults ? (
                    <>
                      {(searchResults.rows && searchResults.rows.length > 0) ||
                      !items.emptyResults ? (
                        <ClickableTableWidget
                          popperReference={searchBox}
                          items={searchResults}
                          rowClickAction={clickAction}
                          searchPopper={true}
                        />
                      ) : (
                        <div
                          style={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxSizing: 'border-box',
                            margin: 'auto 0px',
                          }}
                        >
                          {items.emptyResults.iconId && (
                            <DynamicIcon
                              iconId={items.emptyResults.iconId}
                              // iconId={958}
                              style={{
                                width: 80,
                                height: 80,
                                marginBottom: 40,
                                marginTop: 24,
                              }}
                            />
                          )}
                          <Typography
                            style={{
                              marginBottom: 16,
                              textAlign: 'center',
                              width: '80%',
                              fontSize: 14,
                            }}
                          >
                            {items.emptyResults.message &&
                              items.emptyResults.message
                                .split('\n')
                                .map((str) => (
                                  <p style={{ margin: 0, padding: 0 }}>{str}</p>
                                ))}
                            {/* Looks like this item is currently not a part of your
                            item master. Click the button below to add this item
                            to your item master! */}
                          </Typography>
                          <Button
                            style={{
                              marginBottom: 24,
                            }}
                            variant="contained"
                            color="primary"
                            onClick={() => {
                              if (items.emptyResults.deeplink) {
                                sendAmplitudeData(
                                  'Add item to item master button clicked in Billing screen ',
                                  {
                                    deep_link: items.emptyResults.deeplink,
                                    formBody: { searchString: searchString },
                                    apiType: items.emptyResults.apiType,
                                  }
                                );
                                items.emptyResults.apiType === 1 ||
                                !items.emptyResults.apiType
                                  ? props.setDeepLink(
                                      items.emptyResults.deeplink
                                    )
                                  : props
                                      .handleDeeplink(
                                        items.emptyResults.deeplink,
                                        items.emptyResults.apiType,
                                        { searchString: searchString },
                                        {
                                          doneCallback: (refreshDeeplink) =>
                                            props.setDeepLink(refreshDeeplink),
                                        }
                                      )
                                      .then((response) => {
                                        if (response) {
                                          response.refreshDeeplink &&
                                            (props.setDeepLink || (() => {}))(
                                              response.refreshDeeplink
                                            );
                                          response.userMessage &&
                                            props.setMessage(
                                              response.userMessage
                                            );
                                        }
                                      });
                              }
                            }}
                          >
                            {items.emptyResults.buttonText}
                            {/* Add Item */}
                          </Button>
                        </div>
                      )}
                    </>
                  ) : (
                    <div
                      style={{
                        display: 'flex',
                        width: '100%',
                        height: 100,
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <CircularProgress disableShrink={true} />
                    </div>
                  )}
                </div>
              </ClickAwayListener>
            </Fade>
          )}
        </Popper>
      </div>
      <div ref={searchResultsContainer}></div>
      <div
        style={{
          display: 'flex',
          width: '100%',
          height: 'calc(100% - 50px)',
          paddingTop: 8,
        }}
      >
        {presentItems && (
          <ClickableTableWidget
            onKeyPress={onKeyPress}
            formData={props.formData}
            setFormState={props.setFormState}
            items={presentItems}
            updateAction={handleChange}
            deleteAction={deleteItem}
            focus={focus}
            responseAwaited={responseAwaited}
            setResponseAwaited={setResponseAwaited}
            handleDeeplink={props.handleDeeplink}
            fetchContent={fetchContent}
            setDeepLink={props.setDeepLink}
            tableShortcuts={props.tableShortcuts}
          />
        )}
      </div>
    </>
  );
};

export const InputWithIncrementDecrement = (props) => {
  const { setFormState, _key, val, disableZeroInput } = props;
  const [value, setValue] = React.useState(val || 0);
  React.useEffect(() => {
    val && setValue(val);
  }, [val]);
  return (
    <div style={{ padding: 0 }}>
      <Box
        style={{
          display: 'flex',
          height: '100%',
          minWidth: 100,
          border: '1px solid rgba(0,100,191,0.32)',
          borderRadius: '4px',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box
          style={{
            display: 'flex',
            padding: 0,
            width: 30,
            cursor: 'pointer',
            height: 32,
          }}
          onClick={() => {
            (((!!props.minVal || props.minVal === 0) && value > props.minVal) ||
              (!props.minVal && props.minVal !== 0)) &&
              props.handleChange(parseInt(value) - 1);
          }}
        >
          <IconButton style={{ padding: 2 }}>
            <Remove
              style={{
                marginLeft: 2,
                marginRight: 2,
                color: '#233C97',
                fontSize: 15,
              }}
            />
          </IconButton>
        </Box>
        <Box
          style={{
            flexGrow: 1,
            height: '100%',
            minWidth: '30px',
            borderLeft: '1px solid rgba(0,100,191,0.32)',
            borderRight: '1px solid rgba(0,100,191,0.32)',
            padding: 2,
          }}
        >
          <Input
            value={value}
            disableUnderline={true}
            inputProps={{
              style: {
                color: '#233C97',
                fontWeight: 'bold',
                textAlign: 'center',
                fontSize: 16,
                padding: 5,
              },
            }}
            onKeyPress={(e) => {
              const regex = /^[0-9]*$/;
              if (!regex.test(e.key)) {
                e.preventDefault();
              }
            }}
            onChange={(event) => {
              (event.target.value != 0 || !disableZeroInput) &&
                (!!props.handleChange
                  ? props.handleChange(event.target.value)
                  : setFormState({ [_key]: parseFloat(event.target.value) }));
            }}
            fullWidth={true}
            disableUnderline
          ></Input>
        </Box>
        <Box
          style={{
            display: 'flex',
            padding: 0,
            width: 30,
            cursor: 'pointer',
            height: 32,
          }}
          onClick={() => props.handleChange(parseInt(value) + 1)}
        >
          <IconButton style={{ padding: 2 }}>
            <Add
              style={{
                marginLeft: 2,
                marginRight: 2,
                color: '#233C97',
                fontSize: 15,
              }}
            />
          </IconButton>
        </Box>
      </Box>
    </div>
  );
};
export const MobileSearchAndOrderWidget = ({ searchDeeplink, ...props }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  function useDebounce(callback, delay) {
    const debouncedFn = React.useCallback(
      debounce((...args) => callback(...args), delay),
      [delay]
    );
    return debouncedFn;
  }

  const handleClick = (event) => {
    if (localSearchString) {
      setSearchString(localSearchString);
    } else {
      searchBar.current.focus();
    }
  };
  const searchBar = React.useRef({});

  const [localSearchString, setLocalSearchString] = React.useState('');
  const [searchString, setSearchString] = React.useState('');
  const [showPrice, setShowPrice] = React.useState(false);
  const open = Boolean(anchorEl);
  const id = open ? 'transitions-popper' : undefined;
  const [loading, setLoading] = React.useState(false);
  const [searchResults, setSearchResults] = React.useState([]);
  const [cartItems, setCartItems] = React.useState();
  const [cartPrice, setCartPrice] = React.useState(0);
  const [showTitle, setShowTitle] = React.useState(true);
  const [responseAwaited, setResponseAwaited] = React.useState(false);
  const [selectedFilters, setSelectedFilters] = React.useState(
    !!props.filter && props.filter.selected
      ? { [props.filter.key]: props.filter.selected }
      : {}
  );
  const [avoidRefresh, setAvoidRefresh] = React.useState(false);
  const [hasMoreData, setHasMoreData] = React.useState(true);
  const [nextPage, setNextPage] = React.useState(1);
  const [isLoading, setIsLoading] = React.useState(false);
  const [rendered, setRendered] = React.useState(false);

  const debouncedSearch = useDebounce((nextValue) => {
    setSearchString(nextValue);
  }, 600);

  const handleChange = (event) => {
    const { value: nextValue } = event.target;
    setLocalSearchString(nextValue);
    debouncedSearch(nextValue);
  };
  const handleChangeQty = (formState, setFormState, item, value) => {
    setFormState(() => {
      let remaining = formState.filter((current) => current.id !== item.id);
      let updatedState = [...remaining];
      let currentItem = {
        ...item,
        cartQty: parseInt(value),
      };
      return [...updatedState, { ...currentItem }];
    });
    debouncedUpdate(item, value);
    !value && setResponseAwaited(item.id);
  };
  const getItemValue = (formState, item) => {
    let current = formState.find((element) => element.id === item.id);
    return (current && current.cartQty) || 0;
  };

  const debouncedUpdate = useDebounce((item, value) => {
    updateItemQuanitity(item, value);
  }, 600);

  const updateItemQuanitity = (item, value) => {
    if (value === 0 || !!value) {
      value === 0 &&
        item.updateAction &&
        sendAmplitudeData('Item deleted from cart', {
          deep_link: item.updateAction.deeplink,
          formBody: { deletedItem: item.title.title },
          apiType: item.updateAction.apiType,
        });
      let itemToUpdate = {};
      itemToUpdate[item.id] = value;
      item.updateAction &&
        props
          .handleDeeplink(
            item.updateAction.deeplink,
            item.updateAction.apiType || 2,
            itemToUpdate
          )
          .then((response) => {
            if (response) {
              response.refreshDeeplink &&
                props
                  .handleDeeplink(response.refreshDeeplink)
                  .then((response) => {
                    setResponseAwaited(-1);
                    if (response) {
                      response.items && setCartItems(response.items);
                      response.totalAmount &&
                        setCartPrice(response.totalAmount);
                      response.userMessage &&
                        props.setMessage(response.userMessage);
                    }
                  });
              response.userMessage && props.setMessage(response.userMessage);
            }
          });
    }
  };
  const addToCart = (item) => {
    let itemToAdd = {};
    itemToAdd[item.id] = 1;
    props.addToCartDeeplink &&
      sendAmplitudeData('Add to Cart Button Clicked', {
        deep_link: props.addToCartDeeplink.deeplink,
        formBody: { addedItem: item.title.title },
        apiType: props.addToCartDeeplink.apiType || 2,
      });
    props
      .handleDeeplink(
        props.addToCartDeeplink.deeplink,
        props.addToCartDeeplink.apiType || 2,
        itemToAdd
      )
      .then((response) => {
        if (response) {
          response.refreshDeeplink &&
            props.handleDeeplink(response.refreshDeeplink).then((response) => {
              setResponseAwaited(-1);
              if (response) {
                response.items && setCartItems(response.items);
                response.totalAmount && setCartPrice(response.totalAmount);
                response.userMessage && props.setMessage(response.userMessage);
              }
            });
          response.userMessage && props.setMessage(response.userMessage);
        }
      });
  };
  const bottomRef = React.useRef(null);
  const scrollToTop = () => {
    const div = document.getElementsByClassName('infinite-scroll-component')[0];
    if (div) div.scrollTop = 0;

    // return listStartRef.current?.scrollIntoView({ behavior: 'auto' });
  };

  const scrollToBottom = () =>
    bottomRef.current?.scrollIntoView({ behavior: 'auto' });

  const searchFunction = (searchStr, page = 1, selFilters = {}) => {
    scrollToTop();
    sendAmplitudeData('Search query made', {
      deep_link: searchDeeplink.deeplink,
      formBody: {
        searchString: searchStr,
        filter: selectedFilters,
      },
      apiType: searchDeeplink.apiType || 1,
    });
    props
      .handleDeeplink(
        `/${searchDeeplink.deeplink}/query${
          searchStr ? `/search/${searchStr}` : ''
        }${Object.keys(selFilters || {}).reduce(
          (queryString, currentFilter) =>
            queryString + `/${currentFilter}/${selectedFilters[currentFilter]}`,
          ''
        )}/page/${page}`
      )
      .then((response) => {
        setLoading(false);
        !!searchString ? setShowTitle(false) : setShowTitle(true);
        if (response) {
          response.searchResults && setSearchResults(response.searchResults);
          response.showPrice && setShowPrice(response.showPrice);
          response.loadMore && setHasMoreData(response.loadMore);
          response.loadMore && setNextPage(2);
        }
        setAnchorEl(searchBar.current);
        // searchBar.current.focus();
      });
  };
  const handleNextPage = () => {
    setIsLoading(true);
    setHasMoreData(false);
    hasMoreData &&
      props
        .handleDeeplink(
          `/${searchDeeplink.deeplink}/query${
            searchString ? `/search/${searchString}` : ''
          }${Object.keys(selectedFilters || {}).reduce(
            (queryString, currentFilter) =>
              queryString +
              `/${currentFilter}/${selectedFilters[currentFilter]}`,
            ''
          )}/page/${nextPage}`
        )
        .then((response) => {
          setLoading(false);
          !!searchString ? setShowTitle(false) : setShowTitle(true);
          if (response) {
            response.searchResults &&
              setSearchResults([...searchResults, ...response.searchResults]);
            response.showPrice && setShowPrice(response.showPrice);
            response.loadMore && setHasMoreData(response.loadMore);
            response.loadMore && setNextPage(nextPage + 1);
            setIsLoading(false);
          }
          setAnchorEl(searchBar.current);
          // searchBar.current.focus();
        });
  };

  React.useEffect(() => {
    if (rendered) {
      setLoading(true);
      avoidRefresh && setAvoidRefresh(false);
      if (searchString && Object.keys(selectedFilters).length > 0) {
        setSelectedFilters({});
        setAvoidRefresh(true);
      }

      (searchString || searchString == '') &&
        !avoidRefresh &&
        searchFunction(searchString, 1, {});
      // : setAnchorEl(null);
    } else {
      setRendered(true);
    }
  }, [searchString]);
  React.useEffect(() => {
    setLoading(true);

    avoidRefresh && setAvoidRefresh(false);
    if (searchString && Object.keys(selectedFilters).length > 0) {
      setSearchString('');
      setLocalSearchString('');
      setAvoidRefresh(true);
    }
    (searchString || searchString == '') &&
      !avoidRefresh &&
      setTimeout(() => {
        !Object.keys(selectedFilters).length > 0
          ? searchFunction(searchString, 1, selectedFilters)
          : searchFunction('', 1, selectedFilters);
      }, 10);
    // : setAnchorEl(null);
  }, [selectedFilters]);
  React.useEffect(() => {
    props.cartDeeplink &&
      props.handleDeeplink(props.cartDeeplink.deeplink).then((response) => {
        response && response.items && setCartItems(response.items);
        response.totalAmount && setCartPrice(response.totalAmount);
      });
  }, [props.cartDeeplink]);

  const getTotalCartPrice = () => {
    let cartPrice = 0;
    cartItems &&
      cartItems.forEach(
        (element) =>
          (cartPrice +=
            (element.cartQty || 0) *
            parseFloat(element.calculationParameter || element.mrp || 0))
      );
    return cartPrice.toFixed(2);
  };
  const selectFilter = (key, value) => {
    selectedFilters[props.filter.key] !== value &&
      !loading &&
      setSelectedFilters({
        // ...(selectedFilters || {}),
        [key]: value,
      });
  };
  // React.useEffect(() => {
  //   setCartItems(persistentStore.get('cartItems') || []);
  // }, []);

  React.useEffect(() => {
    persistentStore.set('cartItems', cartItems);
  }, [cartItems]);

  React.useEffect(() => {
    setTimeout(() => {
      searchResults && searchResults.length == 0 && scrollToBottom();
    }, 100);
  }, [searchResults]);

  return (
    <>
      <div style={{ display: 'flex', width: '100%', minHeight: 0 }}>
        <div
          style={{
            padding: '10px 10px 0px',
            width: '100%',
            overflow: 'auto',
            position: 'relative',
            minHeight: 0,
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: 10,
              justifyContent: 'space-between',
            }}
          >
            <div>
              <Typography style={{ fontSize: 22, fontFamily: 'sans-serif' }}>
                Place Order
              </Typography>
            </div>
          </div>
          <TextField
            style={{ marginTop: '5px' }}
            autoComplete="off"
            value={localSearchString}
            autoFocus={true}
            size="small"
            inputRef={searchBar}
            fullWidth={true}
            label={props.hint || 'Search Medicine'}
            id="outlined-start-adornment"
            onKeyPress={(e) => {
              if (e.key == 'Enter') {
                handleClick(e);
              }
            }}
            InputLabelProps={{
              style: { height: '45px', top: '3px' },
            }}
            InputProps={{
              style: {
                height: '45px',
              },
              endAdornment: (
                <InputAdornment position="end">
                  {localSearchString && (
                    <IconButton
                      edge="end"
                      onClick={() => {
                        setLocalSearchString('');
                        searchBar.current.focus();
                        setSearchString('');
                      }}
                    >
                      {<CloseOutlined />}
                    </IconButton>
                  )}
                </InputAdornment>
              ),
            }}
            variant="outlined"
            onChange={handleChange}
          />
          {props.filter && (
            <div className={classes.filterContainer}>
              {(props.filter.items || []).map((curFilter, index) => (
                <Button
                  disableRipple={
                    selectedFilters[props.filter.key] === curFilter.value ||
                    loading
                  }
                  key={index}
                  style={{
                    paddingLeft: 16,
                    paddingRight: 16,
                    border: '1px solid #E2E2E2',
                    marginRight: index < props.filter.items.length - 1 && 12,

                    fontSize: '12px',
                    ...(selectedFilters[props.filter.key] === curFilter.value
                      ? {
                          backgroundColor: '#233C9722',
                          color: '#233C97ff',
                        }
                      : { color: '#898989ff' }),
                    whiteSpace: 'nowrap',
                    minWidth: 'max-content',
                    fontWeight: 'bold',
                  }}
                  onClick={() => {
                    selectFilter(props.filter.key, curFilter.value);
                  }}
                >
                  {curFilter.title}
                  {selectedFilters[props.filter.key] === curFilter.value && (
                    <CloseOutlined
                      onClick={(event) => {
                        event.stopPropagation();
                        setLoading(true);
                        setSelectedFilters({});
                      }}
                      style={{ fontSize: 16, marginLeft: 4 }}
                    />
                  )}
                </Button>
              ))}
            </div>
          )}
          {open && (
            <Box
              id="scrollableDiv"
              style={{
                position: 'relative',
                width: `calc(100%)`,
                height: props.filter
                  ? (cartItems && cartItems.length > 0) ||
                    props.prescriptionOrderDeeplink
                    ? `calc(100vh - 446px)`
                    : `calc(100vh - 392px)`
                  : (cartItems && cartItems.length > 0) ||
                    props.prescriptionOrderDeeplink
                  ? `calc(100vh - 392px)`
                  : `calc(100vh - 338px)`,
                overflow: 'auto',
                borderRadius: 4,
              }}
              open={open}
              anchorEl={anchorEl}
              onClose={() => {
                setAnchorEl(null);
                setSearchString('');
                searchBar.current.focus();
              }}
            >
              <div style={{ height: '100%' }}>
                {searchResults.length > 0 ? (
                  <div style={{ height: '100%' }}>
                    {showTitle && searchResults.title && !loading && (
                      <div
                        style={{
                          zIndex: 10,
                          background: '#ffffff',
                          position: 'sticky',
                          top: 0,
                          minHeight: 0,
                        }}
                      >
                        <Typography
                          variant="h6"
                          style={{
                            padding: '5px 0px 5px 20px',
                            // fontFamily: 'sans-serif',
                            fontWeight: 'bold',
                            color: '#413e3e',
                          }}
                        >
                          {searchResults.title}
                        </Typography>
                        <Divider />
                      </div>
                    )}
                    <div
                      style={{
                        flex: '1 1 auto',
                        height: '100%',
                      }}
                    >
                      <AutoSizer disableWidth>
                        {({ height, width }) => (
                          <InfiniteScroll
                            dataLength={searchResults.length}
                            height={height}
                            next={handleNextPage}
                            hasMore={hasMoreData}
                            loader={
                              <Box display="flex" justifyContent="center" p={1}>
                                <CircularProgress
                                  size={25}
                                  disableShrink={true}
                                />
                              </Box>
                            }
                            scrollableTarget="scrollableDiv"
                          >
                            <OrderSearchResults
                              loading={loading}
                              showPrice={showPrice}
                              searchResults={searchResults}
                              setSearchResults={setSearchResults}
                              setMessage={props.setMessage}
                              cartItems={cartItems}
                              setCartItems={setCartItems}
                              cartPrice={cartPrice}
                              setCartPrice={setCartPrice}
                              handleDeeplink={props.handleDeeplink}
                              addToCartDeeplink={props.addToCartDeeplink}
                              addItem={addToCart}
                              getItemValue={getItemValue}
                              handleChange={handleChangeQty}
                              responseAwaited={responseAwaited}
                              setResponseAwaited={setResponseAwaited}
                            />

                            {isLoading && (
                              <Box display="flex" justifyContent="center" p={1}>
                                <CircularProgress
                                  size={25}
                                  disableShrink={true}
                                />
                              </Box>
                            )}
                          </InfiniteScroll>
                        )}
                      </AutoSizer>
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      width: '100%',
                      height: props.isMobile
                        ? 'inherit'
                        : 'calc(100vh - 404px)',
                      background: '#ffffff',
                      boxSizing: 'border-box',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: props.isMobile ? 'row' : 'column',
                        alignItems: 'center',
                        boxSizing: 'border-box',
                        margin: 'auto 0px',
                      }}
                    >
                      {!props.isMobile && (
                        <DynamicIcon
                          iconId={
                            props.emptyResults && props.emptyResults.iconId
                          }
                          style={{
                            width: 80,
                            height: 80,
                            marginBottom: 40,
                            marginTop: 24,
                          }}
                        />
                      )}
                      <Typography
                        style={{
                          marginBottom: !props.isMobile && 16,
                          textAlign: 'center',
                          width: '80%',
                          fontSize: props.isMobile && 14,
                        }}
                      >
                        {props.emptyResults &&
                          props.emptyResults.message &&
                          props.emptyResults.message
                            .split('\n')
                            .map((str) => (
                              <p style={{ margin: 0, padding: 0 }}>{str}</p>
                            ))}
                      </Typography>
                      <Button
                        style={{
                          marginBottom: !props.isMobile && 10,
                          marginLeft: props.isMobile && 8,
                          padding: props.isMobile && 4,
                        }}
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          if (
                            props.emptyResults &&
                            props.emptyResults.deeplink
                          ) {
                            sendAmplitudeData(
                              'Request button clicked for empty results',
                              {
                                deep_link: props.emptyResults.deeplink,
                                formBody: { searchString: searchString },
                                apiType: props.emptyResults.apiType,
                              }
                            );
                            props.emptyResults.apiType === 1 ||
                            !props.emptyResults.apiType
                              ? props.setDeepLink(props.emptyResults.deeplink)
                              : props
                                  .handleDeeplink(
                                    props.emptyResults.deeplink,
                                    props.emptyResults.apiType,
                                    { searchString: searchString },
                                    {
                                      doneCallback: (refreshDeeplink) =>
                                        props.setDeepLink(refreshDeeplink),
                                    }
                                  )
                                  .then((response) => {
                                    if (response) {
                                      response.refreshDeeplink &&
                                        (props.setDeepLink || (() => {}))(
                                          response.refreshDeeplink
                                        );
                                      response.userMessage &&
                                        props.setMessage(response.userMessage);
                                    }
                                  });
                          }
                        }}
                      >
                        {props.emptyResults && props.emptyResults.buttonText}
                      </Button>
                      <div ref={bottomRef} />
                    </div>
                  </div>
                )}
              </div>
            </Box>
          )}
        </div>
      </div>
      {props.prescriptionOrderDeeplink && (
        <div
          style={{
            display: 'flex',
            padding: props.isMobile ? '6px 10px' : 8,
            background: '#233C97',
            justifyContent: 'center',
            position: 'fixed',
            width: props.isMobile ? '100%' : '700px',
            bottom: 0,
            height: props.isMobile ? 66 : 84,
            cursor: 'pointer',
          }}
          onClick={() => {
            !props.prescriptionOrderDeeplink.apiType ||
            props.prescriptionOrderDeeplink.apiType === 1
              ? props.setDeepLink(props.prescriptionOrderDeeplink.deeplink)
              : props
                  .handleDeeplink(
                    props.prescriptionOrderDeeplink.deeplink,
                    props.prescriptionOrderDeeplink.apiType
                  )
                  .then((response) => {
                    response &&
                      response.refreshDeeplink &&
                      props.setDeepLink(response.refreshDeeplink);
                  });
          }}
        >
          <Button
            startIcon={
              <DynamicIcon
                insideColoredButton
                iconId={props.prescriptionOrderDeeplink.iconId || 166}
                style={{ height: 30, width: 30 }}
              />
            }
            style={{
              color: '#ffffff',
              fontWeight: 'bold',
              fontSize: props.isMobile ? '16px' : '18px',
            }}
          >
            {props.prescriptionOrderDeeplink.title || 'Order Via Prescription'}
          </Button>
        </div>
      )}
      {cartItems && cartItems.length > 0 && (
        <div
          style={{
            display: 'flex',
            padding: props.isMobile ? '6px 10px' : 8,
            background: '#233C97',
            justifyContent: 'space-between',
            position: 'fixed',
            width: props.isMobile ? '100%' : '700px',
            bottom: 0,
            height: props.isMobile ? 66 : 84,
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Typography
              style={{
                fontSize: props.isMobile ? 14 : 16,
                fontWeight: 600,
                color: '#ffffff',
                margin: props.isMobile ? '4px 0 0 5px' : '8px 0 0 5px',
                letterSpacing: 'normal',
              }}
            >
              {cartItems.length} Items
            </Typography>
            <Typography
              style={{
                fontSize: props.isMobile ? 16 : 18,
                fontWeight: 'bold',
                color: '#ffffff',
                margin: props.isMobile ? '5px 0 0 5px' : '10px 0 0 5px',
                letterSpacing: 'normal',
              }}
            >
              {!!cartPrice && (
                <>
                  &#8377;&nbsp;
                  {Number(cartPrice).toLocaleString('en-IN', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </>
              )}
            </Typography>
          </div>
          <Button
            endIcon={<SendRounded />}
            style={{
              color: '#ffffff',
              fontWeight: 'bold',
              fontSize: '17px',
            }}
            onClick={() => {
              props.goToCartDeeplink &&
                sendAmplitudeData('View Cart Button Clicked', {
                  deep_link: props.goToCartDeeplink.deeplink,
                  apiType: props.addToCartDeeplink.apiType || 1,
                });
              props.goToCartDeeplink &&
                props.setDeepLink(props.goToCartDeeplink.deeplink);
            }}
          >
            {props.submitButtonText || 'View Cart'}
          </Button>
        </div>
      )}
    </>
  );
};

export const CartWidget = (props) => {
  const [loading, setLoading] = React.useState(true);
  const [isMobile, setIsMobile] = React.useState(false);
  function useDebounce(callback, delay) {
    const debouncedFn = React.useCallback(
      debounce((...args) => callback(...args), delay),
      [delay]
    );
    return debouncedFn;
  }

  const [cartItems, setCartItems] = React.useState([]);
  const [cartPrice, setCartPrice] = React.useState(0);
  const handleChangeQty = (formState, setFormState, item, value) => {
    setFormState(() => {
      let remaining = formState.filter((current) => current.id !== item.id);
      let updatedState = [...remaining];
      let currentItem = {
        ...item,
        cartQty: parseInt(value),
      };
      return [...updatedState, { ...currentItem }];
    });
    debouncedUpdate(item, value);
    // !value && setResponseAwaited(item.id);
  };
  const getItemValue = (formState, item) => {
    let current = formState.find((element) => element.id === item.id);
    return (current && current.cartQty) || 0;
  };

  const debouncedUpdate = useDebounce((item, value) => {
    updateItemQuanitity(item, value);
  }, 600);

  const updateItemQuanitity = (item, value) => {
    if (value === 0 || !!value) {
      let itemToUpdate = {};
      itemToUpdate[item.id] = value;
      item.updateAction &&
        props
          .handleDeeplink(
            item.updateAction.deeplink,
            item.updateAction.apiType || 2,
            itemToUpdate
          )
          .then((response) => {
            if (response) {
              response.refreshDeeplink &&
                props
                  .handleDeeplink(response.refreshDeeplink)
                  .then((response) => {
                    // setResponseAwaited(-1);
                    if (response) {
                      response.items && setCartItems(response.items);
                      response.totalAmount &&
                        setCartPrice(response.totalAmount);
                      response.userMessage &&
                        props.setMessage(response.userMessage);
                    }
                  });
              response.userMessage && props.setMessage(response.userMessage);
            }
          });
    }
  };
  React.useEffect(() => {
    props.cartDeeplink &&
      props.handleDeeplink(props.cartDeeplink.deeplink).then((response) => {
        response && response.items && setCartItems(response.items);
        response.totalAmount && setCartPrice(response.totalAmount);
        setLoading(false);
      });
  }, [props.cartDeeplink]);
  // React.useEffect(() => {
  //   setCartItems(persistentStore.get('cartItems') || []);
  //   setLoading(false);
  // }, []);
  const handleResize = () => {
    if (window.innerWidth < 600) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };
  React.useEffect(() => {
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  });

  return (
    <div style={{ width: '100%', overflow: 'auto' }}>
      {!loading && (
        <Cart
          submitButtonText={props.submitButtonText || 'Place Order'}
          calculationParameter={props.calculationParameter || 'mrp'}
          hasBackButton={props.hasBackButton}
          isMobile={isMobile}
          getItemValue={getItemValue}
          handleChange={handleChangeQty}
          setDeepLink={props.setDeepLink}
          items={cartItems}
          setCartItems={setCartItems}
          cartPrice={cartPrice}
          setCartPrice={setCartPrice}
          handleDeeplink={props.handleDeeplink}
          placeOrderDeeplink={props.placeOrderDeeplink}
          setMessage={props.setMessage}
          deleteCartDeeplink={props.deleteCartDeeplink}
          title={props.title}
          deliveryMode={props.deliveryMode}
        />
      )}
    </div>
  );
};

export function FileUploadWidget({
  hint,
  value,
  isRequired,
  _key,
  setFormState,
  formData,
  deep_link,
  apiType,
  setMessage,
  handleDeeplink,
  multiSelect,
  allowCameraCapture,
  responseAwaited,
  setResponseAwaited,
  accept,
  displayImage,
  ...props
}) {
  const [previewImage, setPreviewImage] = React.useState(null);
  const filePicker = React.useRef({});
  const [uploading, setUploading] = React.useState(false);
  const fileTypeMapping = {
    excel:
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
    pdf: 'application/pdf, .pdf',
    image: 'image/*',
    audio: 'audio/*',
    video: 'video/*',
    ppt: 'application/vnd.ms-powerpoint',
    doc: 'application/msword, .doc, .docx',
  };
  const acceptedTypes =
    accept &&
    accept.reduce((prev, curr) => prev + fileTypeMapping[curr] + ', ', '');
  React.useEffect(() => {
    value && setFormState({ [_key]: value });
  }, [value]);
  React.useEffect(() => {
    let cachedValue = persistentStore.get(_key);
    !!cachedValue && !value && setFormState({ [_key]: cachedValue });
  }, []);

  return (
    <div
      onClick={() => !uploading && filePicker.current.click()}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '6px 12px',
        border: '1px solid #c4c4c4',
        borderRadius: 6,
        margin: '15px 10px',
        width: 'calc(100% - 20px)',
      }}
    >
      <ImagePreview
        previewImage={previewImage}
        setPreviewImage={setPreviewImage}
      />
      <div
        style={{
          width: 'calc(100% - 40px)',
        }}
      >
        {formData[_key] && formData[_key].length !== 0 ? (
          <>
            {displayImage && (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '100%',
                  flexWrap: 'wrap',
                }}
              >
                {formData[_key].map((file, index) => (
                  <>
                    {file.fileType.includes('image') && (
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          setPreviewImage(file.fileUrl);
                        }}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          position: 'relative',
                          border: '1px solid black',
                          borderRadius: 4,
                          margin: 4,
                        }}
                      >
                        <div
                          style={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                          }}
                        >
                          <IconButton
                            onClick={(e) => {
                              e.stopPropagation();
                              setFormState({
                                [_key]: formData[_key].filter(
                                  (file, i) => i != index
                                ),
                              });
                            }}
                            style={{ padding: 0 }}
                          >
                            <CloseOutlined />
                          </IconButton>
                        </div>
                        <div style={{ padding: 4 }}>
                          <img
                            src={file.fileUrl}
                            style={{
                              marginTop: 24,
                              height: props.isMobile ? '124px' : '180px',
                              width: props.isMobile ? '124px' : '180px',
                              objectFit: 'cover',
                            }}
                          ></img>
                        </div>
                      </div>
                    )}
                  </>
                ))}
              </div>
            )}
            {formData[_key].map((file, index) => (
              <div style={{ width: '80%', display: 'flex' }}>
                {(!displayImage || !file.fileType.includes('image')) && (
                  <>
                    <a
                      onClick={(e) => e.stopPropagation()}
                      href={file.fileUrl}
                      style={{
                        textDecoration: 'none',
                        color: '#808080',
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'baseline',
                        maxWidth: '100%',
                      }}
                      target="_blank"
                    >
                      <div style={{ width: 25 }}>
                        <FileTypeIcons
                          type={file.fileType}
                          style={{ width: 15, height: 15, marginRight: 10 }}
                        />
                      </div>
                      <Typography
                        noWrap
                        style={{
                          width: props.isMobile && 'calc(100vw - 160px)',
                          maxWidth: '100%',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {file.fileName}
                      </Typography>
                    </a>
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        setFormState({
                          [_key]: formData[_key].filter(
                            (file, i) => i != index
                          ),
                        });
                      }}
                      style={{ width: 20, height: 20, marginLeft: 10 }}
                    >
                      <RemoveCircle
                        style={{ color: '#b70000', fontSize: 17.5 }}
                      />
                    </IconButton>
                  </>
                )}
              </div>
            ))}
          </>
        ) : (
          <Typography
            style={{
              color: '#757575',
              paddingLeft: 5,
              paddingRight: 5,
              fontSize: 16,
            }}
          >
            {hint}
          </Typography>
        )}
      </div>
      <div
        style={{ display: 'flex', justifyContent: 'flex-end', width: '40px' }}
      >
        <input
          ref={filePicker}
          multiple={multiSelect}
          required={isRequired}
          id="file-upload"
          type="file"
          hidden
          accept={
            accept
              ? acceptedTypes
              : allowCameraCapture && 'image/*;capture=camera'
          }
          onClick={(event) => (event.target.value = '')}
          onChange={(e) => {
            let uploadedFiles = [];
            if (e.target.files)
              for (let i = 0; i < e.target.files.length; i++) {
                uploadFile(
                  e.target.files[i],
                  () => {
                    setUploading(true);
                    setResponseAwaited(true);
                  },
                  (data, file) => {
                    setUploading(false);
                    setResponseAwaited(false);
                    const payload = {
                      fileUrl: data.fileUrl,
                      time: data.time,
                      fileType: file.type,
                      fileName: file.name,
                    };
                    uploadedFiles = multiSelect
                      ? [...uploadedFiles, payload]
                      : [payload];
                    setFormState({
                      [_key]: [
                        ...((multiSelect && formData[_key]) || []),
                        ...uploadedFiles,
                      ],
                    });
                  },
                  (error = {}) => {
                    setUploading(false);
                    setResponseAwaited(false);
                    setMessage(error.userMessage || error.errorMessage);
                  }
                );
              }
          }}
        />
        <label htmlFor="file-upload">
          <IconButton>
            {uploading ? (
              <CircularProgress size={22} style={{ color: '#233C97' }} />
            ) : (
              <DynamicIcon
                iconId={
                  !!formData[_key] && formData[_key].length > 0 && multiSelect
                    ? 0
                    : 7
                }
                height={25}
                style={{ color: '#233C97' }}
                component="span"
              />
            )}
          </IconButton>
        </label>
      </div>
    </div>
  );
}

export const LocationPicker = ({
  formData,
  setFormState,
  _key,
  hint,
  deep_link,
  handleDeeplink,
  apiType,
  isMandatory,
  value,
  ...props
}) => {
  const [loading, setLoading] = React.useState(false);
  const locationFunction = (coords) => {
    setFormState({
      [_key]: {
        ...formData[_key],
        lat: coords.lat,
        lng: coords.lng,
      },
    });
    deep_link
      ? handleDeeplink(deep_link, apiType || 2, coords).then((response) => {
          response &&
            response.address &&
            setFormState({
              [_key]: {
                lat: coords.lat,
                lng: coords.lng,
                address: response.address,
              },
            });
          setLoading(false);
        })
      : setLoading(false);
  };
  React.useEffect(() => {
    value && setFormState({ [_key]: value });
  }, [value]);
  React.useEffect(() => {
    let cachedValue = persistentStore.get(_key);
    !!cachedValue && !value && setFormState({ [_key]: cachedValue });
  }, []);
  return (
    <>
      <div style={{ padding: '10px' }}>
        <TextField
          onClick={() => {
            if (!loading && isMandatory && !formData[_key]) {
              setLoading(true);
              locationPreProcessor(locationFunction, () => {
                setLoading(false);
              });
            }
          }}
          label={hint}
          variant="outlined"
          fullWidth={true}
          multiline
          value={formData[_key] && formData[_key].address}
          onChange={(e) =>
            setFormState({
              [_key]: { ...formData[_key], address: e.target.value },
            })
          }
          InputLabelProps={{
            shrink: !!formData[_key] && formData[_key].address,
          }}
          InputProps={{
            style: { width: '100%' },
            disableUnderline: true,
            fullWidth: true,
            readOnly: loading && true,
            endAdornment: (
              <InputAdornment position="end">
                <Button
                  variant="contained"
                  style={{
                    background: '#233C97',
                    color: '#ffffff',
                    fontWeight: 'bold',
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    !loading && setLoading(true);
                    !loading &&
                      locationPreProcessor(locationFunction, () => {
                        setLoading(false);
                      });
                  }}
                >
                  {loading ? (
                    <CircularProgress size={22} style={{ color: '#ffffff' }} />
                  ) : (
                    <>
                      {' '}
                      Current
                      <LocationOn
                        style={{ marginLeft: 5, color: '#ffffff' }}
                      />{' '}
                    </>
                  )}
                </Button>
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );
};

export const OtpWidget = (props) => {
  const [phone, setLogin] = React.useState('');
  const [mode, setMode] = React.useState('inputPhone');
  const [userMessage, setUserMessage] = React.useState({
    state: undefined,
    message: undefined,
  });
  const [loading, setLoading] = React.useState(false);
  const [remember, setRemember] = React.useState(true);
  const [otp, setPassword] = React.useState('');
  const requestOTP = (e) => {
    setLoading(true);
    e.preventDefault();
    if (/[0-9]{10}/.test(phone)) {
      props.otpDeeplink &&
        props
          .handleDeeplink(
            props.otpDeeplink.deeplink,
            props.otpDeeplink.apiType || 2,
            {
              phone,
            }
          )
          .then((response) => {
            if (response.error) {
              setLoading(false);
              throw response;
            }
            (response.data || {}).userMessage &&
              setUserMessage({
                message: (response.data || {}).userMessage,
                state: 'message',
              });
            setLoading(false);
            setMode('inputOTP');
          })
          .catch((err) => {
            setLoading(false);
            setUserMessage({
              message: (err.error || {}).userMessage || 'Something went wrong.',
              state: 'error',
            });
          });
    } else {
      setLoading(false);
      alert('Please enter a valid phone number');
      return 0;
    }
  };

  const handleLogin = (e) => {
    e.preventDefault();
    setLoading(true);
    props.loginDeeplink &&
      props
        .handleDeeplink(
          props.loginDeeplink.deeplink,
          props.loginDeeplink.apiType || 2,
          { phone, otp }
        )
        .then((response) => {
          setLoading(false);
          response &&
            response.refreshDeeplink &&
            props.setDeepLink(response.refreshDeeplink);
        })
        .catch((err) => {
          setLoading(false);
          setUserMessage({
            message: (err || {}).userMessage || 'Something went wrong.',
            state: 'error',
          });
        });
  };
  return (
    <LoginScreen
      isFormWidget={true}
      phone={phone}
      setLogin={setLogin}
      mode={mode}
      setMode={setMode}
      otp={otp}
      setPassword={setPassword}
      remember={remember}
      setRemember={setRemember}
      userMessage={userMessage}
      setUserMessage={setUserMessage}
      requestOTP={requestOTP}
      handleLogin={handleLogin}
      title={props.title}
      otpButtonText={props.otpDeeplink.buttonText}
      loginButtonText={props.loginDeeplink.buttonText}
    />
  );
};
export const GoogleLocationPicker = ({
  formData,
  setFormState,
  _key,
  hint,
  deep_link,
  handleDeeplink,
  apiType,
  isMandatory,
  value,
  ...props
}) => {
  const [openDialog, setOpenDialog] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [processingLocation, setProcessingLocation] = React.useState(false);
  const [currentLocation, setCurrentLocation] = React.useState(undefined);
  const [currentMarker, setCurrentMarker] = React.useState(undefined);

  const updateCurrentLocation = (coords) => {
    setCurrentLocation({ lat: coords.lat, lng: coords.lng });
    setLoading(false);
    setProcessingLocation(false);
  };

  const locationFunction = (coords) => {
    setFormState({
      [_key]: {
        ...formData[_key],
        lat: coords.lat,
        lng: coords.lng,
      },
    });
    deep_link
      ? handleDeeplink(deep_link, apiType || 2, coords).then((response) => {
          response &&
            response.address &&
            setFormState({
              [_key]: {
                lat: coords.lat,
                lng: coords.lng,
                address: response.address,
              },
            });
          setLoading(false);
        })
      : setLoading(false);
  };
  React.useEffect(() => {
    value && setFormState({ [_key]: value });
    value &&
      value.lat &&
      value.lng &&
      setCurrentLocation({ ['lat']: value.lat, ['lng']: value.lng });
  }, [value]);
  React.useEffect(() => {
    let cachedValue = persistentStore.get(_key);
    !!cachedValue && !value && setFormState({ [_key]: cachedValue });
  }, []);
  return (
    <>
      <div style={{ padding: '10px' }}>
        <TextField
          onClick={() => {
            if (
              !!formData[_key] &&
              !!formData[_key].lat &&
              !!formData[_key].lng
            )
              setCurrentLocation({
                ['lat']: formData[_key].lat,
                ['lng']: formData[_key].lng,
              });
            else {
              locationPreProcessor(updateCurrentLocation, () => {
                setProcessingLocation(false);
                setLoading(false);
              });
              setLoading(true);
            }

            setOpenDialog(true);
          }}
          label={hint}
          variant="outlined"
          fullWidth={true}
          multiline
          value={formData[_key] && formData[_key].address}
          onChange={(e) =>
            setFormState({
              [_key]: { ...formData[_key], address: e.target.value },
            })
          }
          InputLabelProps={{
            shrink: !!formData[_key] && formData[_key].address,
          }}
          InputProps={{
            style: { width: '100%' },
            disableUnderline: true,
            fullWidth: true,
            readOnly: true,
            endAdornment: (
              <InputAdornment position="end">
                <LocationOn color="primary" style={{ marginRight: 8 }} />
              </InputAdornment>
            ),
          }}
        />
      </div>
      {
        <GoogleLocationSelector
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          isMobile={props.isMobile}
          currentLocation={currentLocation}
          setCurrentLocation={setCurrentLocation}
          value={value}
          loading={loading}
          locationFunction={locationFunction}
          pickCurrentLocation={() =>
            locationPreProcessor(updateCurrentLocation, () => {
              setProcessingLocation(false);
              setLoading(false);
            })
          }
          processingLocation={processingLocation}
          setProcessingLocation={setProcessingLocation}
        />
      }
    </>
  );
};

export const GoogleLocationPlusAddress = ({
  deep_link,
  _key,
  apiType,
  setFormState,
  formData,
  ...props
}) => {
  let google = React.useRef({ current: {} });
  const [processingLocation, setProcessingLocation] = React.useState(false);
  const [currentLocation, setCurrentLocation] = React.useState(
    props.currentLocation
  );
  const [currentMarker, setCurrentMarker] = React.useState(
    `${props.currentLocation.lat},${props.currentLocation.lng}`
  );
  const isSmallScreen = useMediaQuery('(max-height:768px)');

  React.useEffect(() => {
    deep_link &&
      currentLocation &&
      props
        .handleDeeplink(deep_link, apiType || 2, {
          lat: parseFloat((currentLocation || {}).lat) || 0.0,
          lng: parseFloat((currentLocation || {}).lng || 0.0),
        })
        .then((response) => {
          response &&
            response.address &&
            setFormState({
              [_key]: {
                lat: parseFloat((currentLocation || {}).lat || 0.0),
                lng: parseFloat((currentLocation || {}).lng || 0.0),
                address: response.address,
              },
            });
        });
  }, [currentLocation]);

  const dragMarker = (mapProps, map, event) => {
    !processingLocation &&
      setCurrentMarker(`${mapProps.latLng.lat()},${mapProps.latLng.lng()}`);
  };
  const mapDragEnd = (center) => {
    setCurrentMarker(`${center.lat},${center.lng}`);
  };

  React.useEffect(() => {
    deep_link &&
      currentMarker &&
      props
        .handleDeeplink(deep_link, apiType || 2, {
          lat: (getCoords({ location: currentMarker }) || {}).lat || 0.0,
          lng: (getCoords({ location: currentMarker }) || {}).lng || 0.0,
        })
        .then((response) => {
          response &&
            response.address &&
            setFormState({
              [_key]: {
                lat: (getCoords({ location: currentMarker }) || {}).lat || 0.0,
                lng: (getCoords({ location: currentMarker }) || {}).lng || 0.0,
                address: response.address,
              },
            });
        });
  }, [currentMarker]);

  return (
    <div style={{ padding: 10 }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          marginTop: 4,
        }}
      >
        <DynamicIcon
          iconId={154}
          style={{
            height: 14,
            width: 14,
            marginTop: 4,
            marginRight: 4,
          }}
        />
        <Typography
          style={{
            color: '#454545',
            fontSize: isSmallScreen ? 14 : 16,
          }}
        >
          Drag the map to select the location.
        </Typography>
      </div>
      <div style={{ height: '100%' }}>
        <NewMapComponent
          zoom={17}
          googleRef={(ref) => {
            google.current.googleRef = ref;
          }}
          style={{ position: 'relative', height: '100%', width: '100%' }}
          initialCenter={currentLocation}
          center={currentLocation}
          containerStyle={{
            position: 'relative',
            width: '100%',
            height: '40vh',
          }}
          markers={[
            {
              name: 'Current Location',
              icon: 'map-pin',
              google: google.current.googleRef,
              onDragend: dragMarker,
            },
          ]}
          centeredMarker={true}
          onDragEnd={mapDragEnd}
        ></NewMapComponent>
        {formData[_key] && (
          <div style={{ border: '1px solid #8d8d8d', padding: '8px 16px' }}>
            <Typography
              style={{
                color: '#7D808C',
                fontSize: isSmallScreen && 14,
              }}
            >
              Address:
            </Typography>
            <Typography
              style={{
                color: '#282D3F',
                fontWeight: 'bold',
                fontSize: isSmallScreen && 14,
              }}
            >
              {formData[_key].address}
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
};

export const LocationSearchWidget = ({
  formData,
  setFormState,
  _key,
  ...props
}) => {
  const classes = useStyles();
  let searchField = React.useRef({ current: {} });
  const [anchorEl, setAnchorEl] = React.useState(null);
  const isSmallScreen = useMediaQuery('(max-height:768px)');
  const [searchResults, setSearchResults] = React.useState(
    props.selection || []
  );
  const [loading, setLoading] = React.useState(false);
  const [searching, setSearching] = React.useState(false);
  const [typing, setTyping] = React.useState(false);
  const lastUpdated = React.useRef({ current: { time: Date.now() } });
  const debounceHandler = React.useRef({ current: {} });
  const typingInterval = 1000;
  const handleClose = () => {
    setAnchorEl(null);
  };
  const queryFunction = (
    searchString,
    optionsList,
    setList,
    preProcessorResult
  ) => {
    apiGet(
      `/get-locations?search=${searchString}`,
      preProcessorResult.options
    ).then((response) => {
      setList(get(response, ['data'], {}).results);
    });
  };
  const popoverOpen = Boolean(anchorEl);
  const bouncer = () => {
    if (Date.now() - lastUpdated.current.time >= typingInterval) {
      setTyping(true);
      setAnchorEl(searchField.current);
      setSearching(true);
      (searchPreProcessor || ((completedCallback) => completedCallback({})))(
        (result) => {
          !debounceHandler.current.searchString && setAnchorEl(null);
          queryFunction(
            debounceHandler.current.searchString,
            searchResults,
            (list) => {
              setSearchResults(list);
              setSearching(false);
            },
            result
          );
        },
        () => {
          setSearching(false);
          setAnchorEl(null);
        }
      );
      clearInterval(debounceHandler.current.typingInterval);
      setTyping(false);
    }
  };

  const handleSearchType = (event) => {
    debounceHandler.current.searchString = event.target.value;
    lastUpdated.current.time = Date.now();
    if (!typing) {
      debounceHandler.current.typingInterval = setInterval(
        bouncer,
        typingInterval
      );
    }
    setTyping(true);
  };
  const onSubmit = (location) => {
    sendAmplitudeData('Location picked from Map', {
      lat: location.lat,
      lng: location.lng,
    });
    props.apiType === 1 || !props.apiType
      ? props.setDeepLink(props.deeplink)
      : props
          .handleDeeplink(
            props.deeplink,
            props.apiType || 2,
            { [_key]: location },
            {
              doneCallback: (refreshDeeplink) =>
                props.setDeepLink(refreshDeeplink),
            }
          )
          .then((response) => {
            setLoading(false);
            if (response) {
              response.refreshDeeplink &&
                (props.setDeepLink || (() => {}))(response.refreshDeeplink);
              response.userMessage && props.setMessage(response.userMessage);
            }
          });
  };
  return (
    <Box p={1} mt={2}>
      <TextField
        variant="outlined"
        ref={searchField}
        placeholder={props.hint || 'Search'}
        onChange={handleSearchType}
        InputProps={{
          disableUnderline: true,
          startAdornment: (
            <InputAdornment>
              <SearchIcon
                style={{
                  color: '#949494',
                  fontSize: 20,
                  marginTop: -3,
                }}
              />
            </InputAdornment>
          ),
        }}
        size="small"
        style={{
          width: '100%',
          borderRadius: 7,
        }}
      />
      <Box mt={3}>
        <Button
          onClick={() => {
            setLoading(true);
            locationPreProcessor(onSubmit, () => {
              setLoading(false);
            });
          }}
          style={{
            border: '1px solid #C4C4C4',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 16,
            cursor: 'pointer',
            width: '100%',
          }}
        >
          {loading ? (
            <CircularProgress
              disableShrink={true}
              size={22}
              style={{ color: '##233C97' }}
            />
          ) : (
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
                width: '100%',
              }}
            >
              <div style={{ marginRight: 16 }}>
                <MyLocationOutlined style={{ color: '#233C97' }} />
              </div>
              <div>
                <Typography
                  style={{ fontSize: 16, fontWeight: 'bold', color: '#233C97' }}
                >
                  Get current location
                </Typography>
                <Typography
                  style={{ fontSize: 14, color: '#808080', textAlign: 'left' }}
                >
                  Using GPS
                </Typography>
              </div>
            </div>
          )}
        </Button>
      </Box>
      <Popper
        className={classes.popper}
        placement="bottom-start"
        open={popoverOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        style={{
          width: searchField && (searchField.current || {}).offsetWidth,
        }}
      >
        <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
          <Card elevation={8}>
            <SearchBlock
              onSelect={(selected) => {
                onSubmit(getCoords(selected));
              }}
              handleSearchType={handleSearchType}
              searchType={'location'}
              queryFunction={queryFunction}
              isAsyncSearch={true}
              searchPreProcessor={searchPreProcessor}
              isSmallScreen={isSmallScreen}
              searching={searching}
              searchResults={searchResults}
            />
          </Card>
        </ClickAwayListener>
      </Popper>
    </Box>
  );
};

export function DescriptiveDropdownWidget({
  title,
  selection,
  selected,
  helperText,
  _key,
  setFormState,
  handleDeeplink,
  formData,
  showDescription,
  setDeepLink,
  setMessage,
  ...props
}) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  React.useEffect(() => {
    selected && setFormState({ [_key]: selected });
    return () => {
      setAnchorEl(null);
    };
  }, [selected]);

  const onSelect = (selectedItem) => {
    const newState = { [_key]: selectedItem.id };

    setFormState(newState);
    setAnchorEl(null);
  };
  const handleSubmit = (deeplink, apiType, formBody = {}) => {
    apiType === 1 || !apiType
      ? setDeepLink(deeplink)
      : handleDeeplink(deeplink, apiType, formBody, {
          doneCallback: (refreshDeeplink) => setDeepLink(refreshDeeplink),
        }).then((response) => {
          if (response) {
            response.refreshDeeplink &&
              (setDeepLink || (() => {}))(response.refreshDeeplink);
            response.userMessage && setMessage(response.userMessage);
          }
        });
  };

  return (
    <div style={{ padding: '10px' }}>
      <div style={{ width: '100%', maxWidth: '100%' }}>
        {helperText && (
          <div style={{ display: 'flex' }}>
            <DynamicIcon
              iconId={154}
              style={{
                height: 14,
                width: 14,
                marginTop: 4,
                marginRight: 4,
              }}
            />
            <Typography style={{ color: '#707070', fontSize: 14 }}>
              {helperText}
            </Typography>
          </div>
        )}
        <ButtonBase
          className={classes.borderedFieldBase}
          style={{ width: '100%', maxWidth: '100%', textAlign: 'left' }}
        >
          <div
            onClick={(event) => setAnchorEl(event.currentTarget)}
            className={classes.borderedField}
            style={{
              ...(!!anchorEl ? { borderColor: '#7467F0', borderWidth: 2 } : {}),
              maxWidth: '100%',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              color: !!formData[_key] && '#000000',
            }}
          >
            {(selection.find((item) => item.id === formData[_key]) || {})
              .title || title}
            <KeyboardArrowDown style={{ color: '#233C97' }} />
          </div>
        </ButtonBase>
      </div>
      {showDescription &&
        !!formData[_key] &&
        !!selection.find(
          (item) => item.id === (formData[_key] || selected)
        ) && (
          <DescriptionWithIconButtonWidget
            defaultMargin={true}
            title={
              (
                selection.find(
                  (item) => item.id === (formData[_key] || selected)
                ) || {}
              ).title
            }
            subtitle={
              (
                selection.find(
                  (item) => item.id === (formData[_key] || selected)
                ) || {}
              ).subtitle
            }
            iconId={
              (
                selection.find(
                  (item) => item.id === (formData[_key] || selected)
                ) || {}
              ).iconId
            }
            iconButton={props.editOption}
            onButtonClick={() => {
              handleSubmit(
                props.editOption.deeplink,
                props.editOption.apiType,
                { id: formData[_key] }
              );
            }}
          />
        )}

      <Popper
        label={title}
        open={open}
        anchorEl={anchorEl}
        placement="bottom-start"
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        style={{
          width: props.isMobile ? 'calc( 100vw - 20px )' : '30vw',
        }}
        className={classes.popper}
      >
        <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
          <Card elevation={8}>
            <SearchBlock
              searchType={'local'}
              isMobile={props.isMobile}
              onSelect={onSelect}
              selection={selection}
              handleSearchType={() => {}}
            />
            {props.addOption && (
              <ButtonBase
                style={{
                  width: '100%',
                  height: '80%',
                  maxWidth: '100%',
                  borderTop: '1px solid #dddddd',
                }}
              >
                <Button
                  style={{
                    width: '100%',
                    color: '#ffffff',
                    background: '#233C97',
                    fontWeight: 'bold',
                  }}
                  color="primary"
                  size="large"
                  onClick={() => {
                    handleSubmit(
                      props.addOption.deeplink,
                      props.addOption.apiType
                    );
                  }}
                >
                  {props.addOption.title}
                </Button>
              </ButtonBase>
            )}
          </Card>
        </ClickAwayListener>
      </Popper>
    </div>
  );
}

export const EditableDropdownWidget = ({
  _key,
  formData,
  setFormState,
  deep_link,
  apiType,
  handleChange,
  onFieldUpdate,
  initialiseFormState,
  hideCloseIcon,
  handleFocus,
  handleBlur,
  ...props
}) => {
  function useDebounce(callback, delay) {
    const debouncedFn = React.useCallback(
      debounce((...args) => callback(...args), delay),
      [delay]
    );
    return debouncedFn;
  }
  const [selected, setSelected] = React.useState(null);
  const [val, setVal] = React.useState(null);
  const updateFormField = (_key, value, deeplink, apiType, formData) => {
    props
      .handleDeeplink(deeplink, apiType || 2, { ...formData, [_key]: value })
      .then((response) => {
        if (response) {
          response.refreshDeeplink &&
            (onFieldUpdate || props.setDeepLink || (() => {}))(
              response.refreshDeeplink
            );
        }
      });
  };
  const debouncedUpdateFormField = useDebounce(
    (_key, value, deeplink, apiType, formData) => {
      updateFormField(_key, value, deeplink, apiType, formData);
    },
    600
  );

  const handleFormFieldChange = (_key, value, deeplink, apiType, formData) => {
    debouncedUpdateFormField(_key, value, deeplink, apiType, formData);
  };
  React.useEffect(() => {
    (props.selected || props.selected === 0) && setSelected(props.selected);
  }, [props.selected]);
  React.useEffect(() => {
    (!!selected || selected === 0) && setVal(selected);
  }, [selected]);
  React.useEffect(() => {
    !handleChange && setFormState({ [_key]: val });
  }, [val]);
  const options = props.options || [];
  return (
    <div
      style={{
        width: '100%',
        padding: props.insideTable ? 0 : 10,
        minWidth: 160,
      }}
    >
      <Autocomplete
        onFocus={handleFocus || (() => {})}
        onBlur={handleBlur || (() => {})}
        key={props.key}
        size={props.insideTable && 'small'}
        style={props.insideTable ? { marginTop: -8 } : {}}
        fullWidth={true}
        closeIcon={
          hideCloseIcon ? null : (
            <CloseOutlined
              fontSize="small"
              onClick={() => {
                setVal(null);
                (handleChange || (() => {}))(null);
                deep_link &&
                  handleFormFieldChange(
                    _key,
                    null,
                    deep_link,
                    apiType,
                    formData
                  );
              }}
            />
          )
        }
        defaultValue={
          !!props.selected || props.selected === 0
            ? options.find((option) => option.id === props.selected) || {
                title: props.selected,
              }
            : null
        }
        onChange={(e, val) => {
          setSelected(!!val ? val.id || val : null);
          !val && setVal(null);
          (handleChange || (() => {}))(!!val ? val.id || val : null);
          deep_link &&
            handleFormFieldChange(
              _key,
              !!val ? val.id || val : null,
              deep_link,
              apiType,
              formData
            );
        }}
        freeSolo
        forcePopupIcon={!!options && options.length > 0}
        options={options}
        getOptionLabel={(option) => option.title || option}
        getOptionSelected={(option, value) => option.id === value.id}
        renderInput={(params) => (
          <TextField
            onChange={(e) => {
              setSelected(null);
              !!e.target.value ? setVal(e.target.value) : setVal(null);
              (handleChange || (() => {}))(e.target.value || null);
              deep_link &&
                handleFormFieldChange(
                  _key,
                  e.target.value || null,
                  deep_link,
                  apiType,
                  formData
                );
            }}
            fullWidth={true}
            {...params}
            label={props.hint || 'Select'}
            margin="normal"
            variant="outlined"
          />
        )}
        renderOption={(option) => (
          <Box>
            <Typography
              style={{
                color: '#000000',
                fontSize: 16,
                margin: '0px 2px 2px 0px',
              }}
            >
              {option.title}
            </Typography>
            {option.subtitle && (
              <Typography
                style={{
                  color: '#505050',
                  fontSize: 14,
                  padding: '0px 0px 0px 4px',
                  maxWidth: '100%',
                  textOverflow: 'ellipsis',
                }}
              >
                {option.subtitle}
              </Typography>
            )}
          </Box>
        )}
      />
    </div>
  );
};
export const TrackingMap = ({
  deep_link,
  _key,
  apiType,
  setFormState,
  formData,
  statusDeeplink,
  ...props
}) => {
  const classes = useStyles();
  let google = React.useRef({ current: {} });
  const [currentLocation, setCurrentLocation] = React.useState(
    props.currentLocation
  );
  const [mapCenter, setMapCenter] = React.useState(undefined);
  const [mapBounds, setMapBounds] = React.useState([]);
  const [currentOrigin, setCurrentOrigin] = React.useState(props.origin);
  const [currentDestination, setCurrentDestination] = React.useState(
    props.destination
  );

  React.useEffect(() => {
    if (currentOrigin && currentDestination) {
      setMapCenter(getMapCenter(currentOrigin, currentDestination));
      setMapBounds([currentOrigin, currentDestination]);
    }
  }, [currentOrigin, currentDestination]);

  const trackingStatus = (interval, onDone) => {
    props
      .handleDeeplink(statusDeeplink)
      .then((data) => {
        if (data.error) {
          throw data.error;
        }
        if (data && data.refreshDeeplink) {
          interval && clearInterval(interval);
          props.setDeepLink(data.refreshDeeplink);
        } else {
          setCurrentLocation(data.currentLocation);
          setCurrentOrigin(data.currentLocation);
          setCurrentDestination(data.destination);
          (onDone || (() => {}))();
        }
      })
      .catch(console.log);
  };

  React.useEffect(() => {
    if (statusDeeplink) {
      trackingStatus(undefined, () => {
        const interval = setInterval(() => {
          trackingStatus(interval);
        }, 8000);
      });
    }
  }, [statusDeeplink]);

  return (
    <div style={{ padding: 10 }}>
      <div style={{ height: '100%' }}>
        <NewMapComponent
          zoom={17}
          googleRef={(ref) => {
            google.current.googleRef = ref;
          }}
          style={{ position: 'relative', height: '100%', width: '100%' }}
          center={mapCenter}
          bounds={mapBounds}
          containerStyle={{
            position: 'relative',
            width: '100%',
            height: '40vh',
          }}
          markers={[
            {
              name: 'Current Location',
              icon: 'map-pin-delivery',
              anchor: 24,
              size: 40,
              marker: {
                location: !!currentLocation
                  ? `${currentLocation.lat},${currentLocation.lng}`
                  : null,
              },
            },
            {
              name: 'origin',
              icon: 'map-pin',
              label: !!props.origin && props.origin.label,
              styleClass: classes.mapLabel,
              marker: {
                location:
                  !!props.origin && props.origin.lat && props.origin.lng
                    ? `${props.origin.lat},${props.origin.lng}`
                    : null,
              },
            },
            {
              name: 'destination',
              icon: 'map-pin',
              label: !!props.destination && props.destination.label,
              styleClass: classes.mapLabel,
              marker: {
                location:
                  !!props.destination &&
                  props.destination.lat &&
                  props.destination.lng
                    ? `${props.destination.lat},${props.destination.lng}`
                    : null,
              },
            },
          ]}
          polyline={props.showPolyline}
          polylineJourney={{
            pickup: currentLocation || {},
            destination: props.destination || {},
          }}
          polylineAttributes={{
            color: '#2A7FB9',
          }}
        ></NewMapComponent>
      </div>
    </div>
  );
};

export const InputSearchField = ({
  handleDeeplink,
  formData,
  setFormState,
  _key,
  onFieldUpdate,
  pseudoFormState,
  ...props
}) => {
  const classes = useStyles();
  let searchField = React.useRef({ current: {} });
  let searchFieldInputArea = React.useRef({ current: {} });
  const [anchorEl, setAnchorEl] = React.useState(null);
  const isSmallScreen = useMediaQuery('(max-height:768px)');
  const [searchResults, setSearchResults] = React.useState([]);
  const [selectedOption, setSelectedOption] = React.useState();
  const [searching, setSearching] = React.useState(false);
  const [localSearchString, setLocalSearchString] = React.useState('');
  const [typing, setTyping] = React.useState(false);
  const [initialUpdate, setInitialUpdate] = React.useState(false);
  const lastUpdated = React.useRef({ current: { time: Date.now() } });
  const debounceHandler = React.useRef({ current: {} });
  const [savePending, setSavePending] = React.useState(false);
  const typingInterval = 1000;
  const handleClose = () => {
    setAnchorEl(null);
  };
  const onSelection = (deeplink, apiType, val) => {
    const body = { ...formData };
    body[_key] = val;
    handleDeeplink(deeplink, apiType, body).then((response) => {
      response &&
        response.refreshDeeplink &&
        (onFieldUpdate || props.setDeepLink || (() => {}))(
          response.refreshDeeplink
        );
    });
  };
  const emptyResultsHandler = (deeplink, apiType) => {
    if (deeplink) {
      sendAmplitudeData(
        `Empty results ${props.emptyResults.buttonText} button clicked `,
        {
          deep_link: deeplink,
          formBody: { searchString: localSearchString },
          apiType: apiType,
        }
      );

      apiType === 1 || !apiType
        ? props.setDeepLink(deeplink)
        : (props.handleDeepLinkFunction || handleDeeplink)(
            deeplink,
            apiType,
            { searchString: localSearchString },
            {
              doneCallback: (refreshDeeplink) =>
                (props.setDeepLink || props.handleDeepLinkFunction)(
                  refreshDeeplink
                ),
            }
          ).then((response) => {
            if (response) {
              response.refreshDeeplink &&
                (
                  props.setDeepLink ||
                  props.handleDeepLinkFunction ||
                  (() => {})
                )(response.refreshDeeplink);
              response.userMessage && props.setMessage(response.userMessage);
            }
          });
    }
  };
  React.useEffect(() => {
    if (savePending) {
      props.saveDeeplink &&
        (props.saveAction || onSelection)(
          props.saveDeeplink.deeplink,
          props.saveDeeplink.apiType || 1,
          (selectedOption && selectedOption.id) || null
        );
      setSavePending(false);
    }
  }, [pseudoFormState, formData]);
  React.useEffect(() => {
    props.selected && setSelectedOption(props.selected);
    props.selected && setInitialUpdate(true);
  }, [props.selected]);
  React.useEffect(() => {
    if (selectedOption || selectedOption === null) {
      (props.handleSelectOption || ((id) => setFormState({ [_key]: id })))(
        (selectedOption && selectedOption.id) || null
      );
      setLocalSearchString((selectedOption && selectedOption.title) || '');
      initialUpdate
        ? setInitialUpdate(false)
        : props.saveDeeplink && setSavePending(true);
    }
  }, [selectedOption]);
  const queryFunction = (
    searchString,
    optionsList,
    setList,
    preProcessorResult
  ) => {
    props.deeplink &&
      handleDeeplink(props.deeplink, props.apiType || 2, {
        searchString: searchString,
      }).then((data) => {
        data && data.searchResults && setList(data.searchResults);
        props.hideEmptyResults &&
          data &&
          data.searchResults &&
          data.searchResults.length === 0 &&
          setAnchorEl(null);
        setSearching(false);
      });
  };
  const popoverOpen = Boolean(anchorEl);
  const bouncer = () => {
    setSearching(true);
    setAnchorEl(searchField.current);
    setTyping(true);
    !debounceHandler.current.searchString && setAnchorEl(null);
    if (Date.now() - lastUpdated.current.time >= typingInterval) {
      queryFunction(
        debounceHandler.current.searchString,
        searchResults,
        (list) => {
          setSearchResults(list);
          setSearching(false);
        }
      );

      clearInterval(debounceHandler.current.typingInterval);
      setTyping(false);
    }
  };

  const handleSearchType = (event) => {
    setSearching(true);
    setAnchorEl(searchField.current);
    setTyping(true);
    setLocalSearchString(event.target.value);
    !props.disableCustomInput && setFormState({ [_key]: event.target.value });
    debounceHandler.current.searchString = event.target.value;
    lastUpdated.current.time = Date.now();
    if (!typing) {
      debounceHandler.current.typingInterval = setInterval(
        bouncer,
        typingInterval
      );
    }
    setTyping(true);
  };
  const onSubmit = (selected) => {
    setSelectedOption(selected);
    setAnchorEl(null);
  };
  React.useEffect(() => {
    if (
      !props.disableCustomInput &&
      (!formData || (formData && Object.keys(formData).length === 0))
    ) {
      setLocalSearchString('');
      setSelectedOption(null);
    }
  }, [formData]);

  return (
    <div
      style={{ margin: !props.tableCell && 10, width: props.tableCell && 400 }}
    >
      <div style={{ width: '100%', maxWidth: '100%' }}>
        <TextField
          autoComplete="off"
          id="searchField"
          variant="outlined"
          ref={searchField}
          placeholder={props.hint || 'Search'}
          value={localSearchString}
          onChange={handleSearchType}
          inputRef={searchFieldInputArea}
          InputProps={{
            disableUnderline: true,
            startAdornment: (
              <InputAdornment>
                <SearchIcon
                  style={{
                    color: '#949494',
                    fontSize: 20,
                    marginTop: -3,
                  }}
                />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                {!props.saveDeeplink && localSearchString && (
                  <IconButton
                    edge="end"
                    onClick={(event) => {
                      event.stopPropagation();
                      setLocalSearchString('');
                      setSelectedOption(null);
                      searchFieldInputArea.current.focus();
                    }}
                  >
                    {<CloseOutlined />}
                  </IconButton>
                )}
              </InputAdornment>
            ),
          }}
          size={props.tableCell ? 'small' : 'medium'}
          style={{
            width: '100%',
            borderRadius: 7,
          }}
        />
      </div>
      <Popper
        className={classes.popper}
        placement="bottom-start"
        open={popoverOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        style={{
          width: searchField && (searchField.current || {}).offsetWidth,
        }}
      >
        <ClickAwayListener
          onClickAway={(event) => {
            if (
              !searching &&
              !(event && event.path[0] && event.path[0].id === 'searchField')
            ) {
              setAnchorEl(null);
              if (props.disableCustomInput)
                selectedOption && selectedOption.title
                  ? setLocalSearchString(selectedOption.title)
                  : setLocalSearchString('');
            }
          }}
        >
          <Card elevation={8}>
            <SearchBlock
              onSelect={(selected) => {
                onSubmit(selected);
              }}
              handleSearchType={handleSearchType}
              searchType={'table'}
              queryFunction={queryFunction}
              isAsyncSearch={true}
              isSmallScreen={isSmallScreen}
              searching={searching}
              searchResults={searchResults}
              searchPopper={true}
              emptyResults={props.emptyResults}
              emptyResultsHandler={emptyResultsHandler}
            />
          </Card>
        </ClickAwayListener>
      </Popper>
    </div>
  );
};
